import Flatten from 'flatten-js/dist/flatten.commonjs2';
import { tns } from 'tiny-slider';
import NumberFormatter from './utils/number-formatter';
import { cmToMm, mmToCm } from './utils/number-converter';
import { ImperialInputHandler } from './utils/imperial-input';

let { Point, Polygon, Segment } = Flatten;

if (typeof window.parkside === 'undefined') window.parkside = {};
if (typeof window.parkside.zeichentool === 'undefined') window.parkside.zeichentool = {};

window.parkside.zeichentool.initWizard = function (prevStepText, nextStepText) {
  tns({
    container: '#grundriss-tutorial > .slides',
    items: 1,
    slideBy: 'page',
    autoplay: false,
    controlsPosition: 'bottom',
    nav: true,
    navPosition: 'bottom',
    controlsText: [nextStepText, prevStepText],
    loop: false,
  });
};

window.parkside.zeichentool.initLayoutDrawer = function (drawdata, vpx2cmFactor, history_and_redos, storedViewData) {
  dojo.require('dojo.html');
  dojo.require('dojox.gfx');
  dojo.require('dojox.gfx.Moveable');

  dojo.addOnLoad(function () {
    var container = dojo.byId('canvas'),
      container_position = dojo.position(container, true),
      container_position_embedded = dojo.position(container, true),
      container_visible_dimension = { w: jQuery('#canvas').width(), h: jQuery('#canvas').height() },
      defaultHeight = jQuery('#canvas').height(), //height to scale the background image
      toolbarPadding = 142, //width of the toolbar on the right
      s = dojox.gfx.createSurface('canvas'), // instance of surface
      zoomMultiplier = 1.2, //zooming factor
      viewData = {
        //information for display transformation of the drawn shapes
        zoomlevel: 0.0, //current zoom level (integer values)
        pan: {
          x: 0.0,
          y: 0.0, //panning from move activity
        },
        zoompan: {
          x: 0.0,
          y: 0.0, //panning bei non-central zooming
        },
        rotation: {
          //rotation information of the backgriund image
          deg: 0.0, //rotation amount in degrees
          center: {
            //point of rotation applied
            x: container_visible_dimension.w / 2.0,
            y: container_visible_dimension.h / 2.0,
          },
        },
      },
      vpx2cm = NaN, //convertion factior between pixels and centimeters
      historyVpx2cm = NaN, //variable to temporary store a vpx2cm factor for the undo/redo feature
      mindist = 5.0, //Distance in px to trigger snapping. Gets adjusted relative to zoom level.
      minlength = 10.0, //Distance in cm which should be the minimal natural length of a line.
      minangle = 5 * (Math.PI / 180), //minimal angle for drawing lines (radian)
      minAreaSize = 0, //minimal size of areas in cm2 to get accepted
      gridStepSize = 50, //grid size in px (rotation grid)
      roundAccurancy = 0, //number of decimals to round for freely set points (i.e. points without snappoint)
      maxDisplayAccurancy = 2, //max number of decimals to show from pointvalues based on snapppoints
      history = [], //array to store draw status to enable undo feature
      redos = [], //array to store undone steps to enable redo feature
      matrix = dojox.gfx.matrix, //short access to matrix transforamtion functions for rotation
      numberFormatter = new NumberFormatter({}),
      formattingPattern = numberFormatter.isImperial() ? 'feet_inch_fraction' : 'cm',
      formattingPatternScaleBottomImperial = 'feet_inch',
      formattingPatternArea = numberFormatter.isImperial() ? 'ft2' : 'm2',
      isImperial = numberFormatter.isImperial();

    s.whenLoaded(function () {
      s.setDimensions(container_visible_dimension.w, container_visible_dimension.h);

      if (jQuery('#canvas').attr('data-image').length) {
        // init opacity slider and bind function to change the opacity of the
        // background image.
        jQuery('#opacity-slider').slider({
          value: 80,
          orientation: 'horizontal',
          range: 'min',
          animate: false,
        });
        jQuery('#opacity-slider').bind('slide', function (event, ui) {
          jQuery('#canvas svg rect').css('opacity', 1 - ui.value / 100);
        });
      } else {
        // if no background image is used
        //define a default conversion factor to prevent input prompt asking for natural length
        vpx2cm = parseFloat(s.getDimensions().height) / 800.0; //height of surface = 8m
      }

      // Check for IE8. Since no transparency is applied in this browser, disable the transparency slider
      if (navigator.appVersion.indexOf('MSIE 8.') != -1) {
        jQuery('#opacity-slider').slider('disable');
      }

      var group = s.createGroup(),
        helperMeasurementsGroup = s.createGroup(),
        points = [], //points of the area currently drawn
        uniteconfig = {}, //object to temporary store information about areas to unite
        sliceconfig = [], //object to temporary store information about areas to slice
        sliceAreaID = false, //temporary store id of area to slice
        sliceinvalid = false, //flag if currently drawn sliceline is valid
        hoveredAreaId = false, // currently hovered area
        data = {}, //object keeping all data of completed areas
        zoomareas = {}, //object with area data for initial fitting of plan on load
        snappoint = false, //stores snapping point if there is any
        snapindicator = false, //flag if the snappoint inticator should be drawn
        movepoint = false, // stores point which is moved by mover tool
        selectedTool = false, //stores identifier of the currently selected tool
        moveableObj = 'undefined', //stores the dojox Movable instance if there is any
        onmoveShapes = [], //stores all temporary shape objects drawn on mousemove for removal
        cornerShapes = [], //stores dashed lines which indicate alignment with a corner of an area
        templine = false, //stores shape object representing the temporary drawing line that is displayed on mousemove
        bgImage = false, //stores shape object representing the background image
        gridToggle = false, //flag indicating if the grid should be displayed or not
        measurementToggle = true, //flag indicating if the measurement numbers should be displayed or not
        scaleRulerSteps = [50, 100, 150, 200, 250, 500, 1000], //array of steps which should be displayed at the bottom ruler scale
        getUniqueId = function (object, prefix) {
          /*
           * Generate an ID and check if it is a unique propertyname of
           * the given object. Return the found unique ID.
           *
           * Needed since on every page load _.uniqueId gets reset but objects
           * get loaded from session.
           */

          var tempId = 0;
          do {
            tempId = _.uniqueId(prefix);
          } while (object.hasOwnProperty(tempId));
          return tempId;
        },
        addStatusToHistory = function () {
          /*
           * Save the current drawing status to the history array
           */
          history.push({ data: dojo.clone(data), points: dojo.clone(points) });
          redos.length = 0;
          jQuery('#undo').removeClass('disabled');
          jQuery('#redo').addClass('disabled');
        },
        drawBackgroundImage = function () {
          // draw background image if available
          if (jQuery('#canvas').attr('data-image').length) {
            var newWidth =
              (parseFloat(defaultHeight) * parseFloat(jQuery('#canvas').attr('data-width'))) /
              parseFloat(jQuery('#canvas').attr('data-height'));
            var bildpos = global2local({ x: container_visible_dimension.w / 2.0 - newWidth / 2.0, y: 0.0 });
            if (viewData.zoomlevel != 0.0) {
              bgImage = group.createImage({
                x: bildpos.x,
                y: bildpos.y,
                width: newWidth * Math.pow(zoomMultiplier, viewData.zoomlevel),
                height: defaultHeight * Math.pow(zoomMultiplier, viewData.zoomlevel),
                src: 'files/' + jQuery('#canvas').attr('data-image'),
              });
            } else {
              bgImage = group.createImage({
                x: bildpos.x,
                y: bildpos.y,
                width: newWidth,
                height: defaultHeight,
                src: 'files/' + jQuery('#canvas').attr('data-image'),
              });
            }
          }

          // white background rectagle
          var bgrect = group
            .createRect({
              x: 0.0,
              y: 0.0,
              width: parseFloat(s.getDimensions().width),
              height: parseFloat(s.getDimensions().height),
            })
            .setFill('#ffffff');

          // Check for IE8. Since no transparency is applied in this browser, move the white background to the back
          if (navigator.appVersion.indexOf('MSIE 8.') != -1) {
            bgrect.moveToBack();
          }
        },
        refreshBackgroundOpacity = function () {
          // get opacity value from slider widget and applay it via css
          jQuery('#canvas svg rect').css('opacity', 1 - jQuery('#opacity-slider').slider('option', 'value') / 100);
        },
        drawGrid = function () {
          // draw grid to support alignment when rotating the background image
          if (gridToggle) {
            var gridgroup = group.createGroup();
            for (let i = 0; i <= s.getDimensions().width; i += gridStepSize) {
              gridgroup
                .createLine({ x1: i, y1: 0, x2: i, y2: s.getDimensions().height })
                .setStroke({ color: '#ccc', width: 1 });
            }

            for (let i = 0; i <= s.getDimensions().height; i += gridStepSize) {
              gridgroup
                .createLine({ x1: 0, y1: i, x2: s.getDimensions().width, y2: i })
                .setStroke({ color: '#ccc', width: 1 });
            }
          }
        },
        global2local = function (point) {
          // transform a point from the global to the local coordinate system
          var newpoint = { x: 0.0, y: 0.0 };
          newpoint.x = point.x * Math.pow(zoomMultiplier, viewData.zoomlevel) + viewData.pan.x + viewData.zoompan.x;
          newpoint.y = point.y * Math.pow(zoomMultiplier, viewData.zoomlevel) + viewData.pan.y + viewData.zoompan.y;
          return newpoint;
        },
        local2global = function (point) {
          // transform a point from the local to the global coordinate system
          var newpoint = { x: 0.0, y: 0.0 };
          newpoint.x = (point.x - viewData.pan.x - viewData.zoompan.x) * Math.pow(zoomMultiplier, -viewData.zoomlevel);
          newpoint.y = (point.y - viewData.pan.y - viewData.zoompan.y) * Math.pow(zoomMultiplier, -viewData.zoomlevel);
          return newpoint;
        },
        removeDuplicateNeighbourPoints = function (pointarray) {
          /*
           * Go trough an array of points and remove duplicate points
           * that are next to each other.
           * Return an array of unique points.
           */
          var uniquePoints = [];
          for (var i = 0; i < pointarray.length; i++) {
            if (i > 0) {
              if (!(pointarray[i].x == pointarray[i - 1].x && pointarray[i].y == pointarray[i - 1].y)) {
                uniquePoints.push(pointarray[i]);
              }
            } else {
              uniquePoints.push(pointarray[i]);
            }
          }
          return uniquePoints;
        },
        sliceArea = function (sliceconfig) {
          /*
           * Slices an area into 2 areas based on the provided configuration
           */
          var startindex = -1,
            stopindex = -1,
            areaID = sliceAreaID;

          //detect the start eand end of the indices of the points to move to the new area
          jQuery.each(data[areaID].points, function (index, point) {
            if (sliceconfig[0].linesegment == undefined) {
              //slicepoint == a point of the area
              if (point.x === sliceconfig[0].point.x && point.y === sliceconfig[0].point.y) {
                startindex = index;
              }
            } else {
              //slicepoint lies on a line of the area
              if (
                point.x === sliceconfig[0].linesegment[areaID].p2.x &&
                point.y === sliceconfig[0].linesegment[areaID].p2.y
              ) {
                startindex = index;
              }
            }

            if (sliceconfig[1].linesegment == undefined) {
              //slicepoint == a point of the area
              if (point.x === sliceconfig[1].point.x && point.y === sliceconfig[1].point.y) {
                stopindex = index;
              }
            } else {
              //slicepoint lies on a line of the area
              if (
                point.x === sliceconfig[1].linesegment[areaID].p1.x &&
                point.y === sliceconfig[1].linesegment[areaID].p1.y
              ) {
                stopindex = index;
              }
            }
          });

          // correct the indices if needed
          if (startindex > stopindex) {
            var tempstart = stopindex + 1;
            var tempstop = startindex - 1;
            startindex = tempstart;
            stopindex = tempstop;

            var temppos1 = sliceconfig[0];
            var temppos2 = sliceconfig[1];
            sliceconfig[0] = temppos2;
            sliceconfig[1] = temppos1;
          }

          //check if start- and stopindex has been found, otherwise return
          if (startindex === -1 || stopindex === -1) {
            return;
          }

          // get the points of the old area that have to be removed and
          // store them as points of the new area.
          var switchpoints = [];
          for (var i = startindex; i <= stopindex; i++) {
            switchpoints.push(data[areaID].points[i]);
          }

          //overwrite the points of the old area with the new points defined by the sliceline
          data[areaID].points[startindex] = sliceconfig[0].point;
          if (stopindex - startindex > 0) {
            //if more than 1 point of the old area is affected
            data[areaID].points[stopindex] = sliceconfig[1].point;
            //remove points that have been sliced and moved away to a new area
            data[areaID].points.splice(startindex + 1, switchpoints.length - 2);
          } else {
            data[areaID].points.splice(startindex + 1, 0, sliceconfig[1].point);
          }
          //remove duplicate points in old area if there are any
          data[areaID].points = removeDuplicateNeighbourPoints(data[areaID].points);

          // add the start and endpoints to the new area
          switchpoints.unshift(sliceconfig[0].point);
          switchpoints.push(sliceconfig[1].point);
          //remove duplicate points in new area if there are any
          switchpoints = removeDuplicateNeighbourPoints(switchpoints);

          //create the new area
          var idStr = getUniqueId(data, 'area_');
          data[idStr] = { points: dojo.clone(switchpoints), angle: 0 };

          sliceAreaID = false;
          sliceconfig.length = 0;
          redraw();
          addStatusToHistory();
        },
        uniteArea = function (uniteconfig) {
          /*
           * Unites two areas to one based on the provided configuration
           */
          var areapoints1 = dojo.clone(data[uniteconfig.areas[0]].points), // points of old area
            areapoints2 = dojo.clone(data[uniteconfig.areas[1]].points), // points of new area
            startIdx1 = false,
            stopIdx1 = false,
            areaID1 = false,
            startIdx2 = false,
            stopIdx2 = false,
            areaID2 = false;

          // find the uniting points of each of the two areas
          jQuery.each(areapoints1, function (index, point) {
            areaID1 = uniteconfig.areas[0];
            if (point.x === uniteconfig.points[0].x && point.y === uniteconfig.points[0].y) {
              startIdx1 = index;
            }
            if (point.x === uniteconfig.points[1].x && point.y === uniteconfig.points[1].y) {
              stopIdx1 = index;
            }
          });

          jQuery.each(areapoints2, function (index, point) {
            areaID2 = uniteconfig.areas[1];
            if (point.x === uniteconfig.points[0].x && point.y === uniteconfig.points[0].y) {
              startIdx2 = index;
            }
            if (point.x === uniteconfig.points[1].x && point.y === uniteconfig.points[1].y) {
              stopIdx2 = index;
            }
          });

          function sign(x) {
            return typeof x === 'number' ? (x ? (x < 0 ? -1 : 1) : x === x ? 0 : NaN) : NaN;
          }

          // get the walkthrough direction when combining the two areas
          var step1 = sign(startIdx1 - stopIdx1),
            step2 = sign(startIdx2 - stopIdx2);
          if (startIdx1 === 0 && stopIdx1 !== 1) {
            step1 = 1;
          } else if (stopIdx1 === 0 && startIdx1 !== 1) {
            step1 = -1;
          }
          if (startIdx2 === 0 && stopIdx2 !== 1) {
            step2 = 1;
          } else if (stopIdx2 === 0 && startIdx2 !== 1) {
            step2 = -1;
          }

          var combinedArr = []; //array of the combined points

          //area1
          for (var i = 0, j = startIdx1; i < areapoints1.length; i++, j += step1) {
            if (j > areapoints1.length - 1) {
              j = 0;
            } else if (j < 0) {
              j = areapoints1.length - 1;
            }

            combinedArr.push(areapoints1[j]);

            if (j === stopIdx1) {
              break;
            }
          }

          combinedArr.reverse();

          //area 2
          var combinedArr2 = [];
          for (var i = 0, j = startIdx2; i < areapoints2.length; i++, j += step2) {
            if (j > areapoints2.length - 1) {
              j = 0;
            } else if (j < 0) {
              j = areapoints2.length - 1;
            }

            combinedArr2.push(areapoints2[j]);
            combinedArr.push(areapoints2[j]);

            if (j === stopIdx2) {
              break;
            }
          }

          combinedArr.pop();

          //remove duplicate points
          combinedArr = removeDuplicateNeighbourPoints(combinedArr);

          // If the points of the former slice are on a line remove them,
          // otherwise they represent a corner and have to be kept.
          // Detection by checking the angle of slicepoint and its neighbour points.
          var checkangle1 = false;
          var checkangle2 = false;
          for (var i = 0; i < combinedArr.length; i++) {
            if (combinedArr[i].x == uniteconfig.points[0].x && combinedArr[i].y == uniteconfig.points[0].y) {
              if (i == 0) {
                checkangle1 = PTU.calcAngle(combinedArr[combinedArr.length - 1], uniteconfig.points[0], combinedArr[1]);
              } else if (i == combinedArr.length - 1) {
                checkangle1 = PTU.calcAngle(combinedArr[combinedArr.length - 2], uniteconfig.points[0], combinedArr[0]);
              } else {
                checkangle1 = PTU.calcAngle(combinedArr[i - 1], uniteconfig.points[0], combinedArr[i + 1]);
              }
            }

            if (combinedArr[i].x == uniteconfig.points[1].x && combinedArr[i].y == uniteconfig.points[1].y) {
              if (i == 0) {
                checkangle2 = PTU.calcAngle(combinedArr[combinedArr.length - 1], uniteconfig.points[1], combinedArr[1]);
              } else if (i == combinedArr.length - 1) {
                checkangle2 = PTU.calcAngle(combinedArr[combinedArr.length - 2], uniteconfig.points[1], combinedArr[0]);
              } else {
                checkangle2 = PTU.calcAngle(combinedArr[i - 1], uniteconfig.points[1], combinedArr[i + 1]);
              }
            }
          }

          if (
            Math.round(checkangle1 * (180 / Math.PI)) == 180 ||
            Math.round(checkangle1 * (180 / Math.PI)) == 0 ||
            isNaN(Math.round(checkangle1 * (180 / Math.PI)))
          ) {
            var uniquePoints = [];
            for (var i = 0; i < combinedArr.length; i++) {
              if (!(combinedArr[i].x == uniteconfig.points[0].x && combinedArr[i].y == uniteconfig.points[0].y)) {
                uniquePoints.push(combinedArr[i]);
              }
            }
            combinedArr = uniquePoints;
          }

          if (
            Math.round(checkangle2 * (180 / Math.PI)) == 180 ||
            Math.round(checkangle2 * (180 / Math.PI)) == 0 ||
            isNaN(Math.round(checkangle2 * (180 / Math.PI)))
          ) {
            var uniquePoints = [];
            for (var i = 0; i < combinedArr.length; i++) {
              if (!(combinedArr[i].x == uniteconfig.points[1].x && combinedArr[i].y == uniteconfig.points[1].y)) {
                uniquePoints.push(combinedArr[i]);
              }
            }
            combinedArr = uniquePoints;
          }

          // Remove the former independent area
          // and save the now united area.
          var delID = uniteconfig.areas[1];
          var unitedID = uniteconfig.areas[0];
          delete data[delID];
          data[unitedID].points = combinedArr;

          redraw();
          uniteconfig = false;
          addStatusToHistory();
        },
        onRemoveArea = function (ev) {
          // Called by Area Removal Tool
          if (isValidRemove(ev.gfxTarget.areaID)) {
            delete data[ev.gfxTarget.areaID];
            redraw();
            addStatusToHistory();
            switchCursor('default');
          }
        },
        fitPlanToView = function (container) {
          /*
           * Fits the whole drawing to the dimensions of the provided container (drawing area)
           */
          var max_bbx = 0,
            max_bby = 0;

          _.forEach(
            zoomareas,
            function (area) {
              var br = new parkside.poly(area.points).getBoundingRect();

              max_bbx = Math.max(br[1].x, max_bbx);
              max_bby = Math.max(br[1].y, max_bby);
            },
            this
          );

          var rzoom = Math.max(max_bbx / (container.w - 48), max_bby / (container.h - 48));
          viewData.zoomlevel = -1 * Math.ceil(Math.log(rzoom) / Math.log(zoomMultiplier));
          viewData.pan.x =
            Math.floor(0.5 * (container.w - max_bbx * Math.pow(zoomMultiplier, viewData.zoomlevel))) -
            min_bbx * Math.pow(zoomMultiplier, viewData.zoomlevel);
          viewData.pan.y =
            Math.floor(0.5 * (container.h - max_bby * Math.pow(zoomMultiplier, viewData.zoomlevel))) -
            min_bby * Math.pow(zoomMultiplier, viewData.zoomlevel);
          viewData.zoompan.x = 0;
          viewData.zoompan.y = 0;
          mindist = 10.0;
          if (viewData.zoomlevel > 0) {
            for (var i = 0; i < viewData.zoomlevel; i++) {
              mindist = mindist / zoomMultiplier;
            }
          } else if (viewData.zoomlevel < 0) {
            for (var i = viewData.zoomlevel; i < 0; i++) {
              mindist = mindist * zoomMultiplier;
            }
          }
        },
        renderScaleRuler = function () {
          /*
           * Renders the dynamic bottom scale based on the scale steps defined in scaleRulerSteps variable.
           */
          if (!isNaN(vpx2cm)) {
            var rulergrp = group.createGroup();
            var firstScaleMark = 0.0;
            var lastScaleMark = 0.0;
            var cm = Math.ceil((100.0 * Math.pow(zoomMultiplier, -viewData.zoomlevel)) / vpx2cm); //convert 100px to cm

            // find the smallest visible scale step and store its arrayindex
            var stepDiff = Math.abs(scaleRulerSteps[0] - cm);
            var nearestStepIndex = 0;
            for (var i = 1; i < scaleRulerSteps.length; i++) {
              if (Math.abs(scaleRulerSteps[i] - cm) < stepDiff) {
                stepDiff = Math.abs(scaleRulerSteps[i] - cm);
                nearestStepIndex = i;
              }
            }

            var stepx = Math.ceil(
              scaleRulerSteps[nearestStepIndex] * vpx2cm * Math.pow(zoomMultiplier, viewData.zoomlevel)
            ); // local x value of scalestep nearest to 100px
            var xdiff = stepx - 100.0; //calculate difference to 100px
            var xpos = 100.0 + xdiff; //x value of the scale line of the steap nearest to 100px

            // draw the 0 scale mark
            rulergrp
              .createLine({ x1: 0, y1: s.getDimensions().height - 15.0, x2: 0, y2: s.getDimensions().height })
              .setStroke({ color: '#ccc', width: 1 });

            //draw first scale mark
            firstScaleMark = lastScaleMark = rulergrp
              .createLine({ x1: xpos, y1: s.getDimensions().height - 15.0, x2: xpos, y2: s.getDimensions().height })
              .setStroke({ color: '#ccc', width: 1 });

            var text = '';
            var scaleNumberCm = scaleRulerSteps[nearestStepIndex];
            if (isImperial) {
              text = numberFormatter.formatOutput(cmToMm(scaleNumberCm), formattingPatternScaleBottomImperial);
            } else {
              text = scaleRulerSteps[nearestStepIndex] + ' cm';
              if (scaleRulerSteps[nearestStepIndex] === scaleRulerSteps[scaleRulerSteps.length - 1.0]) {
                text = scaleRulerSteps[nearestStepIndex] / 100.0 + ' m';
              }
            }

            rulergrp
              .createText({
                x: xpos + 5.0,
                y: s.getDimensions().height - 6.0,
                text: text,
                align: 'left',
              })
              .setFill('#929292')
              .setFont({ family: 'sans-serif', size: '11px' });

            // draw follow up large scale marks (i.e. multiples of the last step)
            var loopIdx = 1;
            while (s.getDimensions().width - lastScaleMark.getShape().x1 > firstScaleMark.getShape().x1) {
              loopIdx++;
              var text = '';
              var scaleNumberCm = scaleRulerSteps[nearestStepIndex] * loopIdx;
              if (isImperial) {
                text = numberFormatter.formatOutput(cmToMm(scaleNumberCm), formattingPatternScaleBottomImperial);
              } else {
                text = scaleRulerSteps[nearestStepIndex] * loopIdx + ' cm';
                if (scaleRulerSteps[nearestStepIndex] === scaleRulerSteps[scaleRulerSteps.length - 1]) {
                  text = (scaleRulerSteps[nearestStepIndex] * loopIdx) / 100.0 + ' m';
                }
              }

              lastScaleMark = rulergrp
                .createLine({
                  x1: firstScaleMark.getShape().x1 * loopIdx,
                  y1: s.getDimensions().height - 15.0,
                  x2: firstScaleMark.getShape().x1 * loopIdx,
                  y2: s.getDimensions().height,
                })
                .setStroke({ color: '#ccc', width: 1 });

              rulergrp
                .createText({
                  x: firstScaleMark.getShape().x1 * loopIdx + 5.0,
                  y: s.getDimensions().height - 6.0,
                  text: text,
                  align: 'left',
                })
                .setFill('#929292')
                .setFont({ family: 'sans-serif', size: '11px' });
            }
          }
        },
        redraw = function () {
          var i = 0;
          var p = points;
          var atts = { color: '#be0000', width: 2 };

          group.clear();
          s.remove(group);
          group = s.createGroup();
          helperMeasurementsGroup = s.createGroup();
          p = p.slice(0);
          jQuery.each(p, function (index, point) {
            p[index] = global2local(point);
          });

          //draw background
          drawBackgroundImage();
          if (bgImage) {
            //apply rotation
            updateMatrix(bgImage);
          }
          refreshBackgroundOpacity();

          // Disable direct input fields when no point has been drawn so far
          if (points.length && !isNaN(vpx2cm)) {
            jQuery('#direct-point, #direct-line, #coordinates-tab, #length-angle-tab').removeClass('disabled');
          } else {
            jQuery('#direct-point, #direct-line, #coordinates-tab, #length-angle-tab').addClass('disabled');
          }

          // Clear any strored values from slicer or eraser, if they are not selected
          if ((selectedTool != 'slicer' && sliceconfig.length) || (selectedTool != 'slicer' && sliceAreaID)) {
            sliceconfig.length = 0;
            sliceAreaID = false;
          }
          if (selectedTool != 'eraser' && uniteconfig.length) {
            uniteconfig = {};
          }

          // Render points, lines and areas

          // sort the ids so cutouts get drawn in the end
          var sortedIds = Object.keys(data).sort();

          let areaCount = 0;
          let cutoutCount = 0;

          // render lines of completed areas
          for (var id of sortedIds) {
            if (data.hasOwnProperty(id)) {
              if (!data[id].cutout) {
                areaCount++;
              } else {
                cutoutCount++;
              }

              var a = data[id].points.slice(0);
              jQuery.each(a, function (index, point) {
                a[index] = global2local(point);
              });

              if (selectedTool === 'area-remover') {
                //if removal-tool is selected render red clickable polyline shapes to select an area to delete
                var fill = [238, 222, 205, 0.6];
                if (data[id].cutout === true) {
                  fill = [255, 255, 255, 1];
                }
                var polyline = group.createPolyline(a).setFill(fill);

                polyline['areaID'] = id;
                polyline.on('mouseover', function (ev) {
                  if (isValidRemove(ev.gfxTarget.areaID)) {
                    switchCursor('pointer');
                    ev.gfxTarget.setFill([255, 0, 0, 0.3]);
                  }
                });

                if (data[id].cutout === true) {
                  polyline.on('mouseout', function (ev) {
                    switchCursor('default');
                    ev.gfxTarget.setFill([255, 255, 255, 1]);
                  });
                } else {
                  polyline.on('mouseout', function (ev) {
                    switchCursor('default');
                    ev.gfxTarget.setFill([238, 222, 205, 0.6]);
                  });
                }
                polyline.on('click', onRemoveArea);
              } else {
                var polyline = {};
                if (sliceAreaID && id != sliceAreaID) {
                  // If slice-tool is active, display all areas which are not sliced gray
                  polyline = group.createPolyline(a).setFill([217, 217, 217, 0.3]);
                } else {
                  // If draw-tool is selected render polyline shapes to detect hovering.
                  // Needed to prevent any snapping when hovering an completed area.
                  if (data[id].cutout) {
                    polyline = group.createPolyline(a).setFill([255, 255, 255, 1]);
                  } else {
                    polyline = group.createPolyline(a).setFill([238, 222, 205, 0.6]);
                  }
                }
                polyline['areaID'] = id;
                polyline['blocksnap'] = true; //shapes with blocksnap = true prevent any snappingpoint
              }

              for (i = 0; i < a.length; ++i) {
                //draw lines
                if (i) {
                  var line = group
                    .createLine({ x1: a[i - 1].x, y1: a[i - 1].y, x2: a[i].x, y2: a[i].y })
                    .setStroke(atts);
                }
                //draw line between last and first point
                if (i === a.length - 1) {
                  var line = group
                    .createLine({ x1: a[a.length - 1].x, y1: a[a.length - 1].y, x2: a[0].x, y2: a[0].y })
                    .setStroke(atts);
                }

                // if mover is enabled draw points
                if (selectedTool === 'mover') {
                  group
                    .createCircle({ cx: a[i].x, cy: a[i].y, r: 2.5 })
                    .moveToFront()
                    .setStroke(atts)
                    .setFill('#be0000');
                }
              }

              //draw measure numbers if toggled
              if (measurementToggle) renderMeasurementForArea(dojo.clone(data[id].points));
            }
          }

          // points and lines of area currently drawn
          for (i = 0; i < p.length; ++i) {
            group.createCircle({ cx: p[i].x, cy: p[i].y, r: 2.5 }).moveToFront().setStroke(atts).setFill('#be0000');
            if (i) {
              group
                .createLine({ x1: p[i - 1].x, y1: p[i - 1].y, x2: p[i].x, y2: p[i].y })
                .setStroke(atts)
                .moveToFront();
            }
          }

          // render bottom scale ruler
          if (selectedTool !== 'cut-out') {
            renderScaleRuler();
          }
          // render rotation grid
          drawGrid();

          //keep tool status if mover tool is selected
          if (selectedTool === 'mover') {
            jQuery('#move-tool').click();
          }

          if (cutoutCount > 0) {
            disableTool('slice');
            disableTool('erase');
          } else {
            enableTool('slice');
            enableTool('erase');
          }

          //activate "next"-button and measurement toggle button if first area is completed
          if (_.size(data)) {
            jQuery('.btn-next').removeClass('btn-disabled');
            jQuery('#toggle-measurements').show();
            if (measurementToggle) {
              jQuery('#toggle-measurements').addClass('active');
            } else {
              jQuery('#toggle-measurements').removeClass('active');
            }
          } else {
            jQuery('.btn-next').addClass('btn-disabled');
            jQuery('#toggle-measurements').hide();
          }
        },
        updateMatrix = function (shape) {
          //apply rotation value on the provided shape based on the rotation value stored in viewData
          var locCenter = global2local(viewData.rotation.center);
          shape.setTransform([matrix.rotategAt(viewData.rotation.deg, locCenter.x, locCenter.y)]);
        },
        rotateText = function (textShape, degree) {
          var bbox = textShape.getBoundingBox(),
            shape = textShape.getShape(),
            rotatex = bbox.x + bbox.width * 0.5,
            rotatey = bbox.y + bbox.height * 0.5;
          textShape.setTransform([dojox.gfx.matrix.rotategAt(degree, rotatex, rotatey)]);
        },
        renderMeasurementForArea = function (area) {
          /*
           * Render measurement numbers for each line of the provided area
           */

          var g = com.parkside.measure_geometry,
            direction = g.find_poly_direction(area),
            pidx = 0,
            numpoints = area.length,
            linesegs = [];

          //Create linesegment objects for each line
          for (var pi = 0; pi < area.length; pi++) {
            var thispoint = area[pidx];
            var nextpoint = area[g.wrapidx(pidx - direction, numpoints)];
            var lineseg = g.create_line_segment(thispoint, nextpoint);
            linesegs.push(lineseg);
            pidx = g.wrapidx(pidx - direction, numpoints);
          }

          for (var lsi = 0; lsi < linesegs.length; ++lsi) {
            var lineseg = linesegs[lsi],
              pixellength = Math.floor(lineseg.length * Math.pow(zoomMultiplier, viewData.zoomlevel));

            if (pixellength > 45.0) {
              //only go on with calculation if > min-length

              var angle_rad = g.calcAngle2(g.create_point(lineseg.p1.x - 100, lineseg.p1.y), lineseg.p1, lineseg.p2);

              var tmrot = g.calculateTransMatrix(angle_rad);
              var inv = numeric.inv(tmrot);

              var mittelpunkt = {
                  x: lineseg.p1.x + (lineseg.p2.x - lineseg.p1.x) * 0.5,
                  y: lineseg.p1.y + (lineseg.p2.y - lineseg.p1.y) * 0.5,
                },
                textdistance = 10.0 / Math.pow(zoomMultiplier, viewData.zoomlevel),
                mp_transformed = global2local(g.movePointAlongNormal(mittelpunkt, textdistance, tmrot, inv));

              // render edge length for finished area
              const linesegCm = Math.round(lineseg.length / vpx2cm);
              const textLineseg = numberFormatter.formatOutput(cmToMm(linesegCm), formattingPattern, false);
              //Get needed rotation and rotate text
              var text = group // renders length of each finished area edge
                .createText({
                  x: mp_transformed.x,
                  y: mp_transformed.y,
                  text: textLineseg,
                  align: 'middle',
                })
                .setFill('black')
                .setFont({ family: 'sans-serif', size: '12px' });

              if (lineseg.p1.y <= lineseg.p2.y) {
                var angle_rad_text = g.calcAngle2(
                  lineseg.p1,
                  lineseg.p2,
                  g.create_point(lineseg.p2.x + 100, lineseg.p2.y)
                );
              } else {
                var angle_rad_text = g.calcAngle2(
                  lineseg.p2,
                  lineseg.p1,
                  g.create_point(lineseg.p1.x + 100, lineseg.p1.y)
                );
              }

              //correction to get readable direction
              var rotTextDeg = angle_rad_text * (180 / Math.PI);
              if (Math.abs(rotTextDeg) > 90.0) rotTextDeg -= 180;

              //correction of vertical baseline of text to get distance between text and line
              var baseCorrectionPx = 4.0;
              text.setShape({
                y: text.getShape().y + Math.abs(90 - Math.abs(rotTextDeg % 90)) * (baseCorrectionPx / 90.0),
              });

              //rotate text
              rotateText(text, rotTextDeg);
            }
          }
        },
        switchCursor = function (cursorstyle) {
          dojo.style('canvas', 'cursor', cursorstyle);
        },
        isToolEnabled = function (tool) {
          let disabledSpan = jQuery(`#${tool} .icon-disabled`);
          if (disabledSpan.length) {
            return false;
          } else {
            return true;
          }
        },
        enableTool = function (tool) {
          if (isToolEnabled(tool) === false) {
            jQuery(`#${tool} .icon-disabled`).remove();
          }
        },
        disableTool = function (tool) {
          if (isToolEnabled(tool) === true) {
            jQuery(`#${tool}`).append('<span class="icon-disabled"></span>');
          }
        };

      /*
       * Code exeecuted when surface object has been loaded (once after page load)
       */
      //draw background
      drawBackgroundImage();
      refreshBackgroundOpacity();

      //if vpx2cm factor is provided apply it
      if (vpx2cmFactor.length && !isNaN(vpx2cmFactor)) {
        vpx2cm = vpx2cmFactor;
      }

      //if history is provided apply it
      if (history_and_redos !== 'false' && history_and_redos !== undefined && history_and_redos.length) {
        history = jQuery.parseJSON(history_and_redos)[0];
        redos = jQuery.parseJSON(history_and_redos)[1];
        if (history.length) {
          jQuery('#undo').removeClass('disabled');
        }
        if (redos.length) {
          jQuery('#redo').removeClass('disabled');
        }
      }

      //if viewData is provided apply it
      if (storedViewData !== 'false' && storedViewData !== undefined && storedViewData.length) {
        viewData = jQuery.parseJSON(storedViewData);

        if (viewData.zoomlevel > 0) {
          for (var i = 0; i < viewData.zoomlevel; i++) {
            mindist = mindist / zoomMultiplier;
          }
        } else if (viewData.zoomlevel < 0) {
          for (var i = viewData.zoomlevel; i < 0; i++) {
            mindist = mindist * zoomMultiplier;
          }
        }

        if (bgImage) {
          updateMatrix(bgImage);
          jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
        }
      }

      //if drawdata (area data) is provided apply it
      if (drawdata.length && drawdata != 0 && !_.size(data)) {
        data = jQuery.parseJSON(drawdata);
        zoomareas = jQuery.parseJSON(drawdata);

        var min_bby = Number.MAX_VALUE,
          min_bbx = Number.MAX_VALUE;
        _.forEach(
          data,
          function (area) {
            var br = new parkside.poly(area.points).getBoundingRect();
            min_bbx = Math.min(br[0].x, min_bbx);
            min_bby = Math.min(br[0].y, min_bby);
          },
          this
        );

        _.forEach(zoomareas, function (area) {
          _.forEach(area.points, function (point) {
            point.x -= min_bbx;
            point.y -= min_bby;
          });
        });

        fitPlanToView(container_visible_dimension);
        redraw();
      }

      renderScaleRuler();

      var detectIntersection = function (pointfrom, pointto) {
          /*
           * Detect an intersection of a line to be added with all previous lines
           * of the area that is currently drawn.
           * Returns true if the line to be added intersects one of the previous lines.
           * Args:
           *   pointfrom: starting point of line to be added
           * 	 pointto: ending point of line to be added
           */
          var new_segment = new parkside.line_segment(pointfrom, pointto);
          var result = false;
          for (var i = 0; i <= points.length - 3; i++) {
            var temp_old_segment = new parkside.line_segment(points[i], points[i + 1]);
            var intersectionPoint = new_segment.intersectWithLineSegment(temp_old_segment);

            if (!isNaN(intersectionPoint.x) && !isNaN(intersectionPoint.y)) {
              result = true;

              // if the intersection point equals the first and the last point ignore the intersection
              // since in this case the area gets completed.
              if (
                PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(points[0].x, 5) &&
                PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(pointto.x, 5) &&
                PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(points[0].y, 5) &&
                PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(pointto.y, 5)
              ) {
                result = false;
              }
            }
          }
          return result;
        },
        detectIntersectionWithArea = function (pointfrom, pointto) {
          /*
           * Detect an intersection of a line to be added with all previous lines
           * of already completed areas
           * Returns true if the line to be added intersects one of the lines of copleted areas.
           * Args:
           *   pointfrom: starting point of line to be added
           * 	 pointto: ending point of line to be added
           */
          var result = false;

          var new_segment = new parkside.line_segment(pointfrom, pointto);
          for (var id in data) {
            if (data.hasOwnProperty(id)) {
              var temppoints = data[id].points;
              for (var i = 0; i < temppoints.length - 1; i++) {
                var temppoint1 = temppoints[i];
                var temppoint2 = temppoints[i + 1];
                var temp_old_segment = new parkside.line_segment(temppoint1, temppoint2);
                var intersectionPoint = new_segment.intersectWithLineSegment(temp_old_segment);

                if (!isNaN(intersectionPoint.x) && !isNaN(intersectionPoint.y)) {
                  result = true;
                  // if the intersection point is one of the starting or endings points of the segment ignore the intersection
                  if (
                    (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(pointfrom.x, 5) &&
                      PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(pointfrom.y, 5)) ||
                    (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(pointto.x, 5) &&
                      PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(pointto.y, 5)) ||
                    (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(temppoint1.x, 5) &&
                      PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(temppoint1.y, 5)) ||
                    (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(temppoint2.x, 5) &&
                      PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(temppoint2.y, 5))
                  ) {
                    result = false;
                  }
                  if (result) return result; //to skip all other checks
                }
              }

              //check last line (from last point to first point)
              var temppoint1 = temppoints[temppoints.length - 1];
              var temppoint2 = temppoints[0];
              var temp_old_segment = new parkside.line_segment(temppoint1, temppoint2);
              var intersectionPoint = new_segment.intersectWithLineSegment(temp_old_segment);

              if (!isNaN(intersectionPoint.x) && !isNaN(intersectionPoint.y)) {
                result = true;
                // if the intersection point is one of the starting or endings points of the segment ignore the intersection
                if (
                  (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(pointfrom.x, 5) &&
                    PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(pointfrom.y, 5)) ||
                  (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(pointto.x, 5) &&
                    PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(pointto.y, 5)) ||
                  (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(temppoint1.x, 5) &&
                    PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(temppoint1.y, 5)) ||
                  (PTU.roundDecimals(intersectionPoint.x, 5) == PTU.roundDecimals(temppoint2.x, 5) &&
                    PTU.roundDecimals(intersectionPoint.y, 5) == PTU.roundDecimals(temppoint2.y, 5))
                ) {
                  result = false;
                }
                if (result) return result;
              }
            }
          }
          return result;
        },
        addPoint = function (point) {
          /*
           * Checks a given point for validity by calling checkForValidPoint() and
           * adds it to the current points array or creates a new completed area.
           */
          delete point['snapx'];
          delete point['snapy'];

          if (selectedTool === 'cut-out' && !checkForValidCutOutPoint(point)) {
            return;
          } else if (selectedTool === 'drawer' && !checkForValidPoint(point)) {
            return;
          }

          var x = point.x;
          var y = point.y;
          var isCutOut = selectedTool === 'cut-out';

          if (points.length === 0) {
            let areaCount = 0;
            let cutoutCount = 0;

            for (const id in data) {
              if (data.hasOwnProperty(id)) {
                if (!data[id].cutout) {
                  areaCount++;
                } else {
                  cutoutCount++;
                }
              }
            }
          }

          if (points.length > 2 && Math.abs(x - points[0].x) + Math.abs(y - points[0].y) < mindist) {
            //add new completed area
            if (isCutOut) {
              var idstr = getUniqueId(data, 'cutout_');
            } else {
              var idstr = getUniqueId(data, 'area_');
            }

            data[idstr] = { points: points.slice(0), angle: 0, cutout: isCutOut };
            points.length = 0;

            mergeOverlappingCutouts(data);

            //check for minimal area size, delete area if too small
            if (getAreaSize(data[idstr]) < minAreaSize) {
              alert(
                tp_trans.trans(
                  'too_small_area_alert',
                  'too_small_area_alert',
                  { minsize: numberFormatter.formatSquareOutput(cmToMm(minAreaSize), formattingPatternArea) }
                )
              );

              delete data[idstr];

              redraw();
              return;
            }
            addStatusToHistory();
          } else {
            //if no completed area, add the point to the current points area (area is currently drawn)

            points.push({ x: x, y: y });
            addStatusToHistory();
          }
          redraw();

          // if no vpx is defined so far and the 2nd point was added
          // call a dialog to request input of natural length
          if (points.length === 2 && !_.size(data) && isNaN(vpx2cm)) {
            showNaturalLengthDialog();
          }
        },
        clearOnMoveShapes = function () {
          /*
           * Clear all temporary shapes that are drawn on mousemove with the drawing tool.
           * (e.g. temporary line)
           */
          if (onmoveShapes.length) {
            for (var i = 0; i < onmoveShapes.length; i++) {
              onmoveShapes[i].removeShape();
              onmoveShapes[i].destroy();
            }
            onmoveShapes.length = 0;
          }
        },
        recalcVpx2cm = function (natural_length) {
          //set the vpx2cm factor based on the provided natural length of the first line drawn
          if (!isNaN(parseFloat(natural_length))) {
            vpx2cm = Math.sqrt(PTU.distP2P(points[0], points[1])) / parseFloat(natural_length);
          }
        },
        showSnapIndicator = function (snappoint) {
          var localpoint = global2local(snappoint);
          snapindicator = group
            .createCircle({ cx: localpoint.x, cy: localpoint.y, r: 3 })
            .setStroke('#000')
            .setFill('#fff');
        },
        removeSnapIndicator = function () {
          if (snapindicator) {
            snapindicator.removeShape();
            snapindicator.destroy();
            snapindicator = false;
          }
        },
        checkDistancePoint2Lines = function (mousepoint, hide_measure) {
          /*
           * Checks if the current mouseposition is near an existing arealine. (< mindist).
           * In that case the snappoint is set to the intersection with the line based on
           * a 90 degeree projection from the current position.
           */
          var lineseg = {};
          var distance = -1;

          if (selectedTool === 'slicer') {
            //In case of slicer tool, additional information has to be added to snappoint.
            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                var areapoints = data[id].points;

                jQuery.each(areapoints, function (idx, point) {
                  if (idx < areapoints.length - 1) {
                    lineseg = new parkside.line_segment(point, areapoints[idx + 1]);
                  } else {
                    lineseg = new parkside.line_segment(point, areapoints[0]);
                  }

                  var intersecPoint = lineseg.pointProjection(mousepoint);
                  var a = intersecPoint.x - mousepoint.x;
                  var b = intersecPoint.y - mousepoint.y;
                  var distance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

                  if (distance >= 0 && distance < mindist && lineseg.pointOnSegment(intersecPoint)) {
                    if (!snappoint) {
                      snappoint = intersecPoint;
                      snappoint['snapx'] = true;
                      snappoint['snapy'] = true;
                      snappoint['linesegment'] = {};
                      snappoint['linesegment'][id] = lineseg;
                      addLineDistanceMeasureLabels(lineseg, intersecPoint);
                    } else {
                      var lineseginfo = {};
                      lineseginfo[id] = lineseg;
                      snappoint['linesegment'][id] = lineseg; //store all lines that are possible
                      addLineDistanceMeasureLabels(lineseg, intersecPoint);
                    }
                  }
                });
              }
            }
          } else if (_.size(data)) {
            //not slicer tool
            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                var areapoints = data[id].points;

                jQuery.each(areapoints, function (idx, point) {
                  if (idx < areapoints.length - 1) {
                    lineseg = new parkside.line_segment(point, areapoints[idx + 1]);
                  } else {
                    lineseg = new parkside.line_segment(point, areapoints[0]);
                  }

                  var intersecPoint = lineseg.pointProjection(mousepoint);
                  var a = intersecPoint.x - mousepoint.x;
                  var b = intersecPoint.y - mousepoint.y;
                  var distance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

                  if (distance >= 0 && distance < mindist && lineseg.pointOnSegment(intersecPoint)) {
                    snappoint = intersecPoint;
                    snappoint['snapx'] = true;
                    snappoint['snapy'] = true;
                    snappoint['linesegment'] = lineseg;
                    snappoint['areaID'] = id;
                    if (!hide_measure) addLineDistanceMeasureLabels(lineseg, intersecPoint);
                    return false;
                  }
                });
              }
            }
          }
        };

      var addLineDistanceMeasureLabels = function (line_segment, intersectionPoint) {
        /*
         * Render the distances from a point on a linesegment to the start and the end of the segment.
         */

        clearOnMoveShapes();

        var len1 = PTU.roundDecimals(Math.sqrt(PTU.distP2P(line_segment.p1, intersectionPoint)) / vpx2cm, 1);
        const textLen1 = numberFormatter.formatOutput(cmToMm(len1), formattingPattern);
        var len2 = PTU.roundDecimals(Math.sqrt(PTU.distP2P(line_segment.p2, intersectionPoint)) / vpx2cm, 1);
        const textLen2 = numberFormatter.formatOutput(cmToMm(len2), formattingPattern);

        var localpoint1 = global2local(line_segment.p1);
        var text1 = group
          .createText({
            x: localpoint1.x + 10,
            y: localpoint1.y - 3,
            text: textLen1,
            align: 'start',
          })
          .setFill('black')
          .setFont({ family: 'sans-serif', size: '12px' });
        onmoveShapes.push(text1);

        var localpoint2 = global2local(line_segment.p2);
        let text2 = group
          .createText({
            x: localpoint2.x + 10,
            y: localpoint2.y - 3,
            text: textLen2,
            align: 'start',
          })
          .setFill('black')
          .setFont({ family: 'sans-serif', size: '11.5px' });
        onmoveShapes.push(text2);

        // Show distance measure labels on the edges of the drawing area, if the ends of the line are moved out of the visible area
        //LEFT
        if (localpoint1.x < 0 || localpoint2.x < 0) {
          var edgeLineSeg = new parkside.line_segment(
            local2global({ x: 0, y: 0 }),
            local2global({ x: 0, y: container_position.h })
          );
          var edgeIntersection = line_segment.intersectWithLineSegment(edgeLineSeg);
          if (!isNaN(edgeIntersection.x) && !isNaN(edgeIntersection.y)) {
            if (localpoint1.x <= localpoint2.x) {
              text1.setShape({ x: 10, y: global2local(edgeIntersection).y - 10 });
            } else {
              text2.setShape({ x: 10, y: global2local(edgeIntersection).y - 10 });
            }
          }
        }
        //RIGHT
        if (
          localpoint1.x > container_position.w - toolbarPadding ||
          localpoint2.x > container_position.w - toolbarPadding
        ) {
          var edgeLineSeg = new parkside.line_segment(
            local2global({ x: container_position.w - toolbarPadding, y: 0 }),
            local2global({ x: container_position.w - toolbarPadding, y: container_position.h })
          );
          var edgeIntersection = line_segment.intersectWithLineSegment(edgeLineSeg);
          if (!isNaN(edgeIntersection.x) && !isNaN(edgeIntersection.y)) {
            if (localpoint1.x >= localpoint2.x) {
              if (global2local(edgeIntersection).y - 10 - text1.getBoundingBox().height <= 0) {
                text1.setShape({
                  x: container_position.w - toolbarPadding - 10,
                  y: global2local(edgeIntersection).y + 10,
                  align: 'end',
                });
              } else {
                text1.setShape({
                  x: container_position.w - toolbarPadding - 10,
                  y: global2local(edgeIntersection).y - 10,
                  align: 'end',
                });
              }
            } else {
              if (global2local(edgeIntersection).y - 10 - text2.getBoundingBox().height <= 0) {
                text2.setShape({
                  x: container_position.w - toolbarPadding - 10,
                  y: global2local(edgeIntersection).y + 10,
                  align: 'end',
                });
              } else {
                text2.setShape({
                  x: container_position.w - toolbarPadding - 10,
                  y: global2local(edgeIntersection).y - 10,
                  align: 'end',
                });
              }
            }
          }
        }
        //TOP
        if (localpoint1.y < 0 || localpoint2.y < 0) {
          var edgeLineSeg = new parkside.line_segment(
            local2global({ x: 0, y: 0 }),
            local2global({ x: container_position.w - toolbarPadding, y: 0 })
          );
          var edgeIntersection = line_segment.intersectWithLineSegment(edgeLineSeg);
          if (!isNaN(edgeIntersection.x) && !isNaN(edgeIntersection.y)) {
            if (localpoint1.y <= localpoint2.y) {
              if (
                global2local(edgeIntersection).x + 10 + text1.getBoundingBox().width >=
                container_position.w - toolbarPadding
              ) {
                text1.setShape({ x: global2local(edgeIntersection).x, y: 15, align: 'end' });
              } else {
                text1.setShape({ x: global2local(edgeIntersection).x + 10, y: 15 });
              }
            } else {
              if (
                global2local(edgeIntersection).x + 10 + text1.getBoundingBox().width >=
                container_position.w - toolbarPadding
              ) {
                text2.setShape({ x: global2local(edgeIntersection).x, y: 15, align: 'end' });
              } else {
                text2.setShape({ x: global2local(edgeIntersection).x + 10, y: 15 });
              }
            }
          }
        }
        //BOTTOM
        if (localpoint1.y > container_position.h || localpoint2.y > container_position.h) {
          var edgeLineSeg = new parkside.line_segment(
            local2global({ x: 0, y: container_position.h }),
            local2global({ x: container_position.w - toolbarPadding, y: container_position.h })
          );
          var edgeIntersection = line_segment.intersectWithLineSegment(edgeLineSeg);
          if (!isNaN(edgeIntersection.x) && !isNaN(edgeIntersection.y)) {
            if (localpoint1.y >= localpoint2.y) {
              text1.setShape({ x: global2local(edgeIntersection).x + 10, y: container_position.h - 25 });
            } else {
              text2.setShape({ x: global2local(edgeIntersection).x + 10, y: container_position.h - 25 });
            }
          }
        }

        //add white background
        onmoveShapes.push(
          group
            .createRect({
              x: text1.getBoundingBox().x - 4,
              y: text1.getBoundingBox().y - 2,
              height: text1.getBoundingBox().height + 4,
              width: text1.getBoundingBox().width + 8,
            })
            .setFill([255, 255, 255, 0.8])
        );
        onmoveShapes.push(
          group
            .createRect({
              x: text2.getBoundingBox().x - 4,
              y: text2.getBoundingBox().y - 2,
              height: text2.getBoundingBox().height + 4,
              width: text2.getBoundingBox().width + 8,
            })
            .setFill([255, 255, 255, 0.8])
        );
        text1.moveToFront();
        text2.moveToFront();
      };

      var checkCornerSnapping = function (cornerpoint, mousepoint) {
        var localpoint = global2local(cornerpoint);
        var atts = { color: '#9d9d9d', style: 'Dash' };

        if (mousepoint.y >= cornerpoint.y - mindist && mousepoint.y <= cornerpoint.y + mindist) {
          cornerShapes.push(
            group.createLine({ x1: 0, y1: localpoint.y, x2: container_position.w, y2: localpoint.y }).setStroke(atts)
          );

          if (snappoint) {
            snappoint.y = cornerpoint.y;
          } else {
            snappoint = { x: mousepoint.x, y: cornerpoint.y };
          }
          snappoint['snapy'] = true;
        }

        if (mousepoint.x >= cornerpoint.x - mindist && mousepoint.x <= cornerpoint.x + mindist) {
          cornerShapes.push(
            group.createLine({ x1: localpoint.x, y1: 0, x2: localpoint.x, y2: container_position.h }).setStroke(atts)
          );

          if (snappoint) {
            snappoint.x = cornerpoint.x;
          } else {
            snappoint = { x: cornerpoint.x, y: mousepoint.y };
          }
          snappoint['snapx'] = true;
        }
      };

      var checkCornerCrossSnapping = function (mousepoint) {
        // check if mouse is on crosslines of two points of
        // the currently drawn area.
        var snapx = false;
        var snapy = false;

        jQuery.each(points, function (index, point) {
          if (mousepoint.y >= point.y - mindist && mousepoint.y <= point.y + mindist) {
            snapy = point;
          }
          if (mousepoint.x >= point.x - mindist && mousepoint.x <= point.x + mindist) {
            snapx = point;
          }
        });

        if (snapx !== false && snapy !== false) {
          cornerShapes.push(
            group
              .createLine({ x1: 0, y1: global2local(snapy).y, x2: container_position.w, y2: global2local(snapy).y })
              .setStroke({ color: '#9d9d9d', style: 'Dash' })
          );
          cornerShapes.push(
            group
              .createLine({ x1: global2local(snapx).x, y1: 0, x2: global2local(snapx).x, y2: container_position.h })
              .setStroke({ color: '#9d9d9d', style: 'Dash' })
          );
          snappoint = { x: snapx.x, y: snapy.y };
          snappoint['snapx'] = true;
          snappoint['snapy'] = true;
        }
      };

      var checkCombinedCornerSnapping = function (mousepoint) {
        /*
         * When a snappoint has already been found, check additionally if the currentposition is near a cornerpoint.
         * In this case combine the two snappoints.
         */
        if (snappoint) {
          var snapx = false;
          var snapy = false;
          var cornerline = false;

          jQuery.each(points, function (index, point) {
            if (mousepoint.y >= point.y - mindist && mousepoint.y <= point.y + mindist) {
              snapy = point;
            }
            if (mousepoint.x >= point.x - mindist && mousepoint.x <= point.x + mindist) {
              snapx = point;
            }
          });

          if (snapx !== false && snapy === false) {
            cornerline = group
              .createLine({ x1: global2local(snapx).x, y1: 0, x2: global2local(snapx).x, y2: container_position.h })
              .setStroke({ color: '#9d9d9d', style: 'Dash' });
            cornerShapes.push(cornerline);
          }
          if (snapx === false && snapy !== false) {
            cornerline = group
              .createLine({ x1: 0, y1: global2local(snapy).y, x2: container_position.w, y2: global2local(snapy).y })
              .setStroke({ color: '#9d9d9d', style: 'Dash' });
            cornerShapes.push(cornerline);
          }

          if (cornerline && snappoint['linesegment'] != 'undefined') {
            var cornerlineseg = new parkside.line_segment(
              local2global({ x: cornerline.getShape().x1, y: cornerline.getShape().y1 }),
              local2global({ x: cornerline.getShape().x2, y: cornerline.getShape().y2 })
            );
            var intersecPoint = snappoint['linesegment'].intersectWithLineSegment(cornerlineseg);
            if (!isNaN(intersecPoint.x) && !isNaN(intersecPoint.y)) {
              //intersecPoint = local2global(intersecPoint);
              snappoint.x = intersecPoint.x;
              snappoint.y = intersecPoint.y;
              snappoint['snapx'] = true;
              snappoint['snapy'] = true;
              addLineDistanceMeasureLabels(snappoint['linesegment'], intersecPoint);
              delete snappoint['linesegment'];
            }
          }
        }
      };

      var checkCombinedCornerSnappingSlice = function (mousepoint) {
        /*
         * When first slicepoint was set and a snappoint for the second slicepoint has already been found,
         * check additionally for alignment with the first slicepoint. In this case combine the two snappoints.
         */
        if (snappoint && sliceconfig.length) {
          var snapx = false;
          var snapy = false;
          var cornerline = false;

          if (mousepoint.y >= sliceconfig[0].point.y - mindist && mousepoint.y <= sliceconfig[0].point.y + mindist) {
            snapy = sliceconfig[0].point;
          }
          if (mousepoint.x >= sliceconfig[0].point.x - mindist && mousepoint.x <= sliceconfig[0].point.x + mindist) {
            snapx = sliceconfig[0].point;
          }

          if (snapx !== false && snapy === false) {
            cornerline = group
              .createLine({ x1: global2local(snapx).x, y1: 0, x2: global2local(snapx).x, y2: container_position.h })
              .setStroke({ color: '#cdcdcd', style: 'Dash' });
            cornerShapes.push(cornerline);
          }
          if (snapx === false && snapy !== false) {
            cornerline = group
              .createLine({ x1: 0, y1: global2local(snapy).y, x2: container_position.w, y2: global2local(snapy).y })
              .setStroke({ color: '#cdcdcd', style: 'Dash' });
            cornerShapes.push(cornerline);
          }

          if (cornerline && snappoint['linesegment'] != 'undefined') {
            var cornerlineseg = new parkside.line_segment(
              local2global({ x: cornerline.getShape().x1, y: cornerline.getShape().y1 }),
              local2global({ x: cornerline.getShape().x2, y: cornerline.getShape().y2 })
            );
            var intersecPoint = snappoint.linesegment[sliceAreaID].intersectWithLineSegment(cornerlineseg);

            if (!isNaN(intersecPoint.x) && !isNaN(intersecPoint.y)) {
              snappoint.x = intersecPoint.x;
              snappoint.y = intersecPoint.y;
            }
          }
        }
      };

      /**
       * First, checks if move is valid with isValidMove().
       * Then, additonally checks if the three points aren't collinear
       *
       * @param {Object} point point to check
       * @param {number} pointIndex index of the point inside existingPoints
       * @param {Object[]} points array of existing points
       * @returns {boolean} validity of given triangle
       */
      var isValidTriangle = function (point, pointIndex, existingPoints, areaID) {
        var points = _.clone(existingPoints);
        points[pointIndex] = point;

        if (!isValidMove(point, pointIndex, existingPoints, areaID)) {
          return false;
        }

        while (pointIndex--) points.push(points.shift());

        // check imaginary segment between pointIndex -1 and pointIndex +1
        var distance = getDistanceFromLineSegment(point, points[points.length - 1], points[1]);
        if (distance !== false && distance <= mindist) {
          return false;
        }

        // check imaginary line between pointIndex +1 and pointIndex +2 and -1,-2
        distance = getDistanceFromLine(point, points[1], points[2]);
        if (distance !== false && distance <= mindist) {
          return false;
        }
        distance = getDistanceFromLine(point, points[points.length - 1], points[points.length - 2]);
        if (distance !== false && distance <= mindist) {
          return false;
        }

        return true;
      };

      /**
       * Checks if the given point lies nearby (mindist)
       * an existing linesegment of the given area.
       *
       * @param {Object} point point to check
       * @param {number} pointIndex index of the point inside existingPoints
       * @param {Object[]} points array of existing points
       * @returns {boolean} validity of given area
       */
      var isValidMove = function (point, pointIndex, existingPoints, areaID) {
        let points = _.clone(existingPoints);
        points[pointIndex] = point;

        // make the new point the first element in the points array
        while (pointIndex--) points.push(points.shift());

        // check min dinstance of new point to all other existing edges
        for (let i = 1; i < points.length - 1; i++) {
          const distance = getDistanceFromLineSegment(point, points[i], points[i + 1]);

          if (distance !== false && distance <= mindist) {
            return false;
          }
        }

        //check min dinstance of new point to all other existing edges of other areas
        let polyPoints = data[areaID].points.map(p => new Point(p.x, p.y));
        let polygon = new Polygon();
        polygon.addFace(polyPoints);

        for (const id in data) {
          if (data.hasOwnProperty(id) && id !== areaID) {
            let otherPoly = new Polygon();
            otherPoly.addFace(data[id].points.map(p => new Point(p.x, p.y)));

            if (polygon.distanceTo(otherPoly)[0] <= mindist) {
              return false;
            }
          }
        }

        return true;
      };

      /**
       * Unites points which are collinear
       *
       * @param {Object[]} points array of  points
       */
      var uniteCollinearPoints = function (points) {
        let toRemove = [];
        for (let i = 0; i < points.length; i++) {
          let distance = getDistanceFromLineSegment(
            points[(i + 1) % points.length],
            points[i],
            points[(i + 2) % points.length]
          );

          if (distance !== false && distance <= 0.01) {
            toRemove.push(i + 1);
          }
        }

        for (let i = toRemove.length - 1; i >= 0; i--) {
          points.splice(toRemove[i], 1);
        }
        if (toRemove.length) {
          return true;
        }

        return false;
      };

      /**
       *
       * @param {*} areaData
       */
      var mergeOverlappingCutouts = function (areaData) {
        for (let id in areaData) {
          if (areaData[id].cutout) {
            let polyPoints = areaData[id].points.map(p => new Point(p.x, p.y));
            let polygon = new Polygon();
            polygon.addFace(_.clone(polyPoints));

            for (let id2 in areaData) {
              if (id !== id2 && areaData[id2].cutout) {
                var contains = true;
                for (const point of areaData[id2].points) {
                  if (!polygon.contains(new Point(point.x, point.y))) {
                    contains = false;
                    break;
                  }
                }
                if (contains) {
                  delete areaData[id2];
                }
              }
            }
          }
        }
      };

      var removeOrphanedCutouts = function (areaData) {
        for (let id_cutout in areaData) {
          if (areaData[id_cutout].cutout) {
            let contained = false;

            for (let id_area in areaData) {
              if (id_cutout !== id_area && !areaData[id_area].cutout) {
                let polyPoints = areaData[id_area].points.map(p => new Point(p.x, p.y));
                let polygon = new Polygon();
                polygon.addFace(_.clone(polyPoints));

                let outside = false;
                for (const point of areaData[id_cutout].points) {
                  if (!polygon.contains(new Point(point.x, point.y))) {
                    outside = true;
                    break;
                  }
                }

                if (outside) continue;

                contained = true;
                break;
              }
            }
            if (!contained) {
              delete areaData[id_cutout];
            }
          }
        }
      };

      /**
       * Checks if it's eligible to remove the given area
       *
       * @param {number} areaID
       */
      var isValidRemove = function (areaID) {
        let polyPoints = data[areaID].points.map(p => new Point(p.x, p.y));
        let polygon = new Polygon();
        polygon.addFace(_.clone(polyPoints));

        for (let id in data) {
          if (data[id].cutout && id !== areaID) {
            for (let point of data[id].points) {
              if (polygon.contains(new Point(point.x, point.y))) {
                return false;
              }
            }
          }
        }

        return true;
      };

      /**
       * Calculates the distance of a point
       * perpendicular to the given line
       *
       * @param {Object} point point to calculate the distance from
       * @param {Object} p1 point 1 of line
       * @param {Object} p2 point 2 of line
       * @returns {number|boolean} distance or false if there was a calculation error
       */
      var getDistanceFromLine = function (point, p1, p2) {
        var line = new parkside.line_segment(p1, p2);
        var intersecPoint = line.pointProjection(point);

        var a = intersecPoint.x - point.x;
        var b = intersecPoint.y - point.y;
        var distance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

        if (distance >= 0) {
          return distance;
        } else {
          return false;
        }
      };

      /**
       * Calculates the distance of a point
       * perpendicular to the given line
       *
       * @param {Object} point point to calculate the distance from
       * @param {Object} p1 point 1 of line
       * @param {Object} p2 point 2 of line
       * @returns {number|boolean} distance, if point can be projected onto the line, otherwise false
       */
      var getDistanceFromLineSegment = function (point, p1, p2) {
        var line = new parkside.line_segment(p1, p2);
        var intersecPoint = line.pointProjection(point);

        var distance = getDistanceFromLine(point, p1, p2);

        if (line.pointOnSegment(intersecPoint)) {
          return distance;
        }
      };

      var showNaturalLengthDialog = function () {
        /*
         * Show a dialog box to require the user to provide the
         * natural length auf the line previously drawn.
         */

        //define fancybox overlay
        jQuery('a#natural-length-caller').fancybox({
          hideOnContentClick: false,
          hideOnOverlayClick: true,
          transitionIn: 'none',
          transitionOut: 'none',
          overlayShow: true,
          overlayOpacity: 0.9,
          overlayColor: '#474540',
          image: false,
          titleShow: false,
          padding: 0,
          margin: 0,
          width: 300,
          height: 155,
          onStart: function () {
            if (!jQuery('#draw-section.fullscreen').length) {
              jQuery('body').css({ overflow: 'hidden' });
            }
            if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length <= 0) {
              jQuery('#fancybox-wrap').wrap("<div class='fancybox-wrap-no-scroll'></div>");
            }
            jQuery('#fancybox-close').append('<span class="fa fa-times fa-lg"></span>');
          },
          onComplete: function () {
            jQuery('#natural-length .apply-link').click(function (e) {
              e.preventDefault();
              let naturalLengthValue = 0;
              if (isImperial) {
                const naturalLengthImperialHandler = new ImperialInputHandler(
                  document.getElementById('drawing_tool_manual_point_natural_length')
                );
                naturalLengthValue = mmToCm(naturalLengthImperialHandler.value);
              } else {
                naturalLengthValue = parseFloat(jQuery('input[name=natural_length_input]').val());
              }

              if (naturalLengthValue < minlength) {
                alert(
                  tp_trans.trans('too_short_length_alert', 'too_short_length_alert', {
                    minlength: numberFormatter.formatSquareOutput(cmToMm(minlength), formattingPattern),
                  })
                );
              } else {
                recalcVpx2cm(naturalLengthValue);
                jQuery.fancybox.close();
              }
            });
            if (isImperial) {
              window.setTimeout(function () {
                jQuery('input[name=natural_length_input]').focus().select();
              }, 10);
            }
          },
          onCleanup: function () {
            //if no valid value was provided by user
            if (isNaN(vpx2cm)) {
              points.pop();
              history.pop();
              redraw();
            }
          },
          onClosed: function () {
            if (jQuery('#fancybox-wrap').parent('.fancybox-wrap-no-scroll').length) {
              jQuery('#fancybox-wrap').unwrap();
            }
            jQuery('body').css({ overflow: '' });
            redraw();
          },
        });
        // call fancybox overlay
        jQuery('a#natural-length-caller').click();
      };

      var applyZoom = function (type, zoomPoint) {
        /*
         * Redraw the whole drawing with a zoomlevel applied.
         * Args:
         *   type: String value "in" or "out" to init a zoom-in or zoom-out process.
         *   zoomPoint: Point object as reference on surface to which the zoom is applied. (= center of surface if left empty)
         */
        var surfaceZoomPoint = { x: 0, y: 0 };
        if (type === 'in') {
          if (!zoomPoint) {
            surfaceZoomPoint = {
              x: parseFloat(s.getDimensions().width) / 2.0,
              y: parseFloat(s.getDimensions().height) / 2.0,
            };
          } else {
            surfaceZoomPoint = zoomPoint;
          }

          var globalDiff = local2global(surfaceZoomPoint);

          viewData.zoomlevel++;

          var f = Math.pow(zoomMultiplier, viewData.zoomlevel) - Math.pow(zoomMultiplier, viewData.zoomlevel - 1.0);
          var diffx = -f * globalDiff.x;
          var diffy = -f * globalDiff.y;

          viewData.zoompan.x += diffx;
          viewData.zoompan.y += diffy;

          // recalculate minimal snapping distance in relation to new zoomlevel
          mindist = mindist / zoomMultiplier;

          redraw();
        } else if (type === 'out') {
          viewData.zoomlevel--;

          if (!zoomPoint) {
            surfaceZoomPoint = {
              x: parseFloat(s.getDimensions().width) / 2.0,
              y: parseFloat(s.getDimensions().height) / 2.0,
            };
          } else {
            surfaceZoomPoint = zoomPoint;
          }
          var globalDiff = local2global(surfaceZoomPoint);
          var f = Math.pow(zoomMultiplier, viewData.zoomlevel) - Math.pow(zoomMultiplier, viewData.zoomlevel - 1.0);
          var diffx = -f * globalDiff.x;
          var diffy = -f * globalDiff.y;

          viewData.zoompan.x -= diffx;
          viewData.zoompan.y -= diffy;

          // recalculate minimal snapping distance in relation to new zoomlevel
          mindist = mindist * zoomMultiplier;

          redraw();
        }
      };

      s.on('mousedown', function (ev) {
        if (
          selectedTool === 'drawer' &&
          !(!points.length && ev.gfxTarget.getShape().type === 'polyline') //block first points inside an existing area
        ) {
          var mousexpos = ev.pageX - container_position.x,
            mouseypos = ev.pageY - container_position.y;

          var globalmousepoint = local2global({
            x: mousexpos,
            y: mouseypos,
          });

          if (snappoint) {
            // if a snappoint is active add the current snapppoint instead of the current mouseposition

            if (snappoint.snapy && snappoint.snapx) {
              //both dimensions should be based on the snappoint
              addPoint({ x: snappoint.x, y: snappoint.y });
            } else if (isNaN(snappoint.snapy)) {
              //if only y-dimension is defined by snappoint
              if (!isNaN(vpx2cm) && points.length) {
                // take y-dimension from snappoint and recalulate x-dimension based on a rounded value (i.e. displayed value)
                var len_y_cm = PTU.roundDecimals(
                  (points[points.length - 1].y - globalmousepoint.y) / vpx2cm,
                  roundAccurancy
                );
                var recalcY = -(len_y_cm * vpx2cm - points[points.length - 1].y);
                addPoint({ x: snappoint.x, y: recalcY });
              } else {
                addPoint({ x: snappoint.x, y: snappoint.y });
              }
            } else if (isNaN(snappoint.snapx)) {
              //if only x-dimension is defined by snappoint
              if (!isNaN(vpx2cm) && points.length) {
                // take x-dimension from snappoint and recalulate y-dimension based on a rounded value (i.e. displayed value)
                var len_x_cm = PTU.roundDecimals(
                  (globalmousepoint.x - points[points.length - 1].x) / vpx2cm,
                  roundAccurancy
                );
                var recalcX = len_x_cm * vpx2cm + points[points.length - 1].x;
                addPoint({ x: recalcX, y: snappoint.y });
              } else {
                addPoint({ x: snappoint.x, y: snappoint.y });
              }
            }
          } else {
            if (points.length && !isNaN(vpx2cm)) {
              var len_x_cm = PTU.roundDecimals(
                (globalmousepoint.x - points[points.length - 1].x) / vpx2cm,
                roundAccurancy
              );
              var len_y_cm = PTU.roundDecimals(
                (points[points.length - 1].y - globalmousepoint.y) / vpx2cm,
                roundAccurancy
              );
              var recalcX = len_x_cm * vpx2cm + points[points.length - 1].x;
              var recalcY = -(len_y_cm * vpx2cm - points[points.length - 1].y);

              addPoint({ x: recalcX, y: recalcY });
            } else {
              addPoint(globalmousepoint);
            }
          }
        } else if (selectedTool === 'slicer') {
          if (snappoint && !sliceinvalid) {
            //if current sliceposition is not invalid. Detected in mousemove.

            var mousexpos = ev.pageX - container_position.x;
            var mouseypos = ev.pageY - container_position.y;

            var globalmousepoint = local2global({
              x: mousexpos,
              y: mouseypos,
            });

            var config = { linesegment: snappoint.linesegment, point: { x: snappoint.x, y: snappoint.y } };
            sliceconfig.push(config);

            if (sliceconfig.length > 1) {
              //when second slicepoint is set, call slice function.
              sliceArea(sliceconfig);
            }
          }
        } else if (selectedTool === 'eraser') {
          if (uniteconfig) {
            // uniteconfig gets detected in mousemove.
            uniteArea(uniteconfig);
          }
        } else if (selectedTool === 'cut-out') {
          // Cut out tool - check if inside an exsisting completed area
          var mousexpos = ev.pageX - container_position.x,
            mouseypos = ev.pageY - container_position.y;

          var globalmousepoint = local2global({
            x: mousexpos,
            y: mouseypos,
          });

          if (snappoint) {
            // if a snappoint is active add the current snapppoint instead of the current mouseposition

            if (snappoint.snapy && snappoint.snapx) {
              //both dimensions should be based on the snappoint
              addPoint({ x: snappoint.x, y: snappoint.y });
            } else if (isNaN(snappoint.snapy)) {
              //if only y-dimension is defined by snappoint
              if (!isNaN(vpx2cm) && points.length) {
                // take y-dimension from snappoint and recalulate x-dimension based on a rounded value (i.e. displayed value)
                var len_y_cm = PTU.roundDecimals(
                  (points[points.length - 1].y - globalmousepoint.y) / vpx2cm,
                  roundAccurancy
                );
                var recalcY = -(len_y_cm * vpx2cm - points[points.length - 1].y);
                addPoint({ x: snappoint.x, y: recalcY });
              } else {
                addPoint({ x: snappoint.x, y: snappoint.y });
              }
            } else if (isNaN(snappoint.snapx)) {
              //if only x-dimension is defined by snappoint
              if (!isNaN(vpx2cm) && points.length) {
                // take x-dimension from snappoint and recalulate y-dimension based on a rounded value (i.e. displayed value)
                var len_x_cm = PTU.roundDecimals(
                  (globalmousepoint.x - points[points.length - 1].x) / vpx2cm,
                  roundAccurancy
                );
                var recalcX = len_x_cm * vpx2cm + points[points.length - 1].x;
                addPoint({ x: recalcX, y: snappoint.y });
              } else {
                addPoint({ x: snappoint.x, y: snappoint.y });
              }
            }
          } else {
            if (points.length && !isNaN(vpx2cm)) {
              var len_x_cm = PTU.roundDecimals(
                (globalmousepoint.x - points[points.length - 1].x) / vpx2cm,
                roundAccurancy
              );
              var len_y_cm = PTU.roundDecimals(
                (points[points.length - 1].y - globalmousepoint.y) / vpx2cm,
                roundAccurancy
              );
              var recalcX = len_x_cm * vpx2cm + points[points.length - 1].x;
              var recalcY = -(len_y_cm * vpx2cm - points[points.length - 1].y);

              addPoint({ x: recalcX, y: recalcY });
            } else {
              addPoint(globalmousepoint);
            }
          }
        }
      });
      var checkForValidPoint = function (checkpoint) {
        /*
         * Checks for unallowed intersections if the provided point
         * (checkpoint) would be added.
         * Returns true if point is valid or false if point is invalid.
         */

        // check if the point lies within an existing area or cutout
        for (const id in data) {
          if (data.hasOwnProperty(id)) {
            let polyPoints = data[id].points.map(p => new Point(p.x, p.y));
            let polygon = new Polygon();
            polygon.addFace(_.clone(polyPoints));

            if (polygon.contains(new Point(checkpoint.x, checkpoint.y))) {
              let isOnEdge = false;

              polygon.edges.forEach(edge => {
                if (edge.contains(new Point(checkpoint.x, checkpoint.y))) {
                  isOnEdge = true;
                }
              });

              // don't return false if the point lies on the edge of the polygon
              if (!isOnEdge) {
                return false;
              }
            }
          }
        }

        //check for minimal length of a line in pixels
        if (points.length) {
          var dist =
            Math.sqrt(PTU.distP2P(points[points.length - 1], checkpoint)) *
            Math.pow(zoomMultiplier, viewData.zoomlevel);
          var minlengthPx = minlength * vpx2cm * Math.pow(zoomMultiplier, viewData.zoomlevel);
          if (dist < minlengthPx) {
            return false;
          }
        }

        //check if the angle of the new line is not lower than the allowed minimal angle
        if (points.length > 1) {
          var angle = PTU.calcAngle(points[points.length - 2], points[points.length - 1], checkpoint);
          if (angle < minangle) {
            return false;
          }
        }

        //check if the new line would intersect if another line of the area currently drawn
        if (points.length >= 2) {
          if (detectIntersection(points[points.length - 1], checkpoint)) {
            return false;
          }
        }

        //check if the line would intersesct with another already completed area
        if (points.length && _.size(data)) {
          if (detectIntersectionWithArea(points[points.length - 1], checkpoint)) {
            return false;
          }
        }
        return true;
      };

      var checkForValidCutOutPoint = function (checkpoint) {
        /*
         * Checks for unallowed intersections if the provided point
         * (checkpoint) would be added.
         * Returns true if point is valid or false if point is invalid.
         */

        // check if the point lies within an existing area and not inside an existing cutout
        let insideArea = false;
        for (const id in data) {
          if (data.hasOwnProperty(id)) {
            let polyPoints = data[id].points.map(p => new Point(p.x, p.y));
            let polygon = new Polygon();
            polygon.addFace(_.clone(polyPoints));

            if (polygon.contains(new Point(checkpoint.x, checkpoint.y))) {
              if (data[id].cutout === true) {
                return false;
              } else {
                insideArea = true;
              }
            }
          }
        }
        if (!insideArea) {
          return false;
        }

        //check for minimal length of a line in pixels
        if (points.length) {
          var dist =
            Math.sqrt(PTU.distP2P(points[points.length - 1], checkpoint)) *
            Math.pow(zoomMultiplier, viewData.zoomlevel);
          var minlengthPx = minlength * vpx2cm * Math.pow(zoomMultiplier, viewData.zoomlevel);
          if (dist < minlengthPx) {
            return false;
          }
        }

        // check min dinstance of new point to all other existing edges
        for (var id in data) {
          if (data.hasOwnProperty(id)) {
            var temppoints = data[id].points;
            var distance = getDistanceFromLineSegment(checkpoint, temppoints[0], temppoints[temppoints.length - 1]);
            if (distance !== false && distance <= mindist) {
              return false;
            }

            for (var i = 0; i < temppoints.length - 1; i++) {
              distance = getDistanceFromLineSegment(checkpoint, temppoints[i], temppoints[i + 1]);
              if (distance !== false && distance <= mindist) {
                return false;
              }
            }
          }
        }

        //check min dinstance of new point to all other existing edges of other areas
        if (points.length > 0) {
          const segment = new Segment(
            new Point(points[points.length - 1].x, points[points.length - 1].y),
            new Point(checkpoint.x, checkpoint.y)
          );

          for (const id in data) {
            if (data.hasOwnProperty(id)) {
              let polygon = new Polygon();
              polygon.addFace(data[id].points.map(p => new Point(p.x, p.y)));

              if (polygon.distanceTo(segment)[0] <= mindist) {
                return false;
              }
            }
          }
        }

        //check if the angle of the new line is not lower than the allowed minimal angle
        if (points.length > 1) {
          var angle = PTU.calcAngle(points[points.length - 2], points[points.length - 1], checkpoint);
          if (angle < minangle) {
            return false;
          }
        }

        //check if the new line would intersect if another line of the area currently drawn
        if (points.length >= 2) {
          if (detectIntersection(points[points.length - 1], checkpoint)) {
            return false;
          }
        }

        //check if the line would intersesct with another already completed area
        if (_.size(data) && points.length) {
          if (detectIntersectionWithArea(points[points.length - 1], checkpoint)) {
            return false;
          }
        }

        return true;
      };

      var getAreaSize = function (area) {
        /*
         * Calculate and return the approx area size
         */
        var poly = new parkside.poly(area.points);
        var height = poly.getBoundingRect()[1].y - poly.getBoundingRect()[0].y;
        var tessWidth = height * 0.0125; //influences the accuracy
        var tessellation = new parkside.tessellation(poly, 0, tessWidth);

        var flaeche = _.reduce(
          tessellation.rows,
          function (flaeche, row) {
            return (
              flaeche +
              _.reduce(
                row.blocks,
                function (breite, block) {
                  return breite + (block.end - block.begin) / vpx2cm;
                },
                0
              ) *
                ((row.bottom - row.top) / vpx2cm)
            );
          },
          0
        );
        return flaeche;
      };

      s.on('mousemove', function (ev) {
        //Fixing the offset when window is scrolled - binding on scroll doesn't work
        container_position = dojo.position(container, true);

        var mousexpos = ev.pageX - parseFloat(container_position.x),
          mouseypos = ev.pageY - parseFloat(container_position.y);

        var mousepoint = local2global({
          x: mousexpos,
          y: mouseypos,
        });
        mousexpos = mousepoint.x;
        mouseypos = mousepoint.y;

        var x = mousexpos,
          y = mouseypos;

        var strokeatts = { color: '#be0000', style: 'Solid', width: 1 };

        hoveredAreaId = null;
        if (ev.gfxTarget && ev.gfxTarget.getShape().type === 'polyline' && ev.gfxTarget.areaID != undefined) {
          if (!hoveredAreaId) {
            hoveredAreaId = ev.gfxTarget.areaID;
          } else if (sliceAreaID != ev.gfxTarget.areaID) {
            hoveredAreaId = ev.gfxTarget.areaID;
          }
        }

        //clear all temporary drawing helpers / indicators
        snappoint = false;
        removeSnapIndicator();
        if (cornerShapes.length) {
          for (var i = 0; i < cornerShapes.length; i++) {
            cornerShapes[i].removeShape();
            cornerShapes[i].destroy();
          }
          cornerShapes.length = 0;
        }
        clearOnMoveShapes();

        /*
         * Snapping Checks
         * The first match gets applied and all others ignored.
         */
        if (selectedTool === 'drawer' || selectedTool === 'cut-out') {
          // check against points of the area currently drawn
          for (var i = points.length - 1; i >= 0; --i) {
            if (Math.abs(x - points[i].x) < mindist && Math.abs(y - points[i].y) < mindist) {
              x = points[i].x;
              y = points[i].y;
              snappoint = points[i];
              snappoint['snapx'] = true;
              snappoint['snapy'] = true;
            }
          }

          // check against the points of completed areas
          if (!snappoint) {
            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                for (var i = data[id].points.length - 1; i >= 0; --i) {
                  if (Math.abs(x - data[id].points[i].x) < mindist && Math.abs(y - data[id].points[i].y) < mindist) {
                    x = data[id].points[i].x;
                    y = data[id].points[i].y;
                    snappoint = data[id].points[i];
                    snappoint['snapx'] = true;
                    snappoint['snapy'] = true;
                  }
                }
              }
            }
          }

          // check if mouse is on crosslines of two points of
          // the currently drawn area.
          if (!snappoint) {
            checkCornerCrossSnapping({ x: mousexpos, y: mouseypos });
          }

          // check against the lines of completed areas
          if (!snappoint) {
            checkDistancePoint2Lines({ x: mousexpos, y: mouseypos });
            checkCombinedCornerSnapping({ x: mousexpos, y: mouseypos });
          }

          // check against imaginary vertical and horizontal lines originating from already drawn points
          //
          // ev.gfxTarget.blocksnap: on all shapes that block lines of cornerpoints
          // 		this property is set to true (i.e. polylines and
          //		templine when moving over an existing area)
          if (!snappoint) {
            jQuery.each(points, function (index, point) {
              checkCornerSnapping(point, { x: mousexpos, y: mouseypos });
            });

            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                for (var i = data[id].points.length - 1; i >= 0; --i) {
                  checkCornerSnapping(data[id].points[i], { x: mousexpos, y: mouseypos });
                }
              }
            }
          }

          // special measurements for cut-out tool
          if (selectedTool === 'cut-out' && hoveredAreaId) {
            renderHelperMeasurements(hoveredAreaId, { x: mousexpos, y: mouseypos });

            if (!checkForValidCutOutPoint({ x: mousexpos, y: mouseypos })) {
              strokeatts.style = 'Dash';
            }
          }

          // show the snappoint indicator if any match was found in the checks above
          if (snappoint) {
            showSnapIndicator(snappoint);
          }
        }

        //when first point was set draw temporary feedbackline
        if (points.length) {
          //Check the minimal distance between the current mouse position and the last point added.
          x = Math.abs(mousexpos - points[points.length - 1].x) < mindist ? points[points.length - 1].x : mousexpos;
          y = Math.abs(mouseypos - points[points.length - 1].y) < mindist ? points[points.length - 1].y : mouseypos;

          // After the previous snappoint-checks, apply any found snappoint
          // by repositioning the target of the line to be drawn
          if (snappoint) {
            x = snappoint.x;
            y = snappoint.y;
          }

          if ((points.length && selectedTool === 'drawer') || selectedTool === 'cut-out') {
            // calculate the measure number to display
            if (snappoint) {
              // calculate depending on which dimensions of the snappoint are snapped
              if (snappoint.snapy && snappoint.snapx) {
                var len_cm = PTU.roundDecimals(
                  Math.sqrt(PTU.distP2P(points[points.length - 1], { x: x, y: y })) / vpx2cm,
                  maxDisplayAccurancy
                );
                var len_x_cm = PTU.roundDecimals((x - points[points.length - 1].x) / vpx2cm, maxDisplayAccurancy);
                var len_y_cm = PTU.roundDecimals((points[points.length - 1].y - y) / vpx2cm, maxDisplayAccurancy);
              } else if (isNaN(snappoint.snapy)) {
                var len_cm = PTU.roundDecimals(
                  Math.sqrt(PTU.distP2P(points[points.length - 1], { x: x, y: y })) / vpx2cm,
                  roundAccurancy
                );
                var len_x_cm = PTU.roundDecimals((x - points[points.length - 1].x) / vpx2cm, maxDisplayAccurancy);
                var len_y_cm = PTU.roundDecimals((points[points.length - 1].y - y) / vpx2cm, roundAccurancy);
              } else if (isNaN(snappoint.snapx)) {
                var len_cm = PTU.roundDecimals(
                  Math.sqrt(PTU.distP2P(points[points.length - 1], { x: x, y: y })) / vpx2cm,
                  roundAccurancy
                );
                var len_x_cm = PTU.roundDecimals((x - points[points.length - 1].x) / vpx2cm, roundAccurancy);
                var len_y_cm = PTU.roundDecimals((points[points.length - 1].y - y) / vpx2cm, maxDisplayAccurancy);
              }
            } else {
              var len_cm = PTU.roundDecimals(
                Math.sqrt(PTU.distP2P(points[points.length - 1], { x: x, y: y })) / vpx2cm,
                roundAccurancy
              );
              var len_x_cm = PTU.roundDecimals((x - points[points.length - 1].x) / vpx2cm, roundAccurancy);
              var len_y_cm = PTU.roundDecimals((points[points.length - 1].y - y) / vpx2cm, roundAccurancy);
            }

            if (isNaN(len_x_cm)) len_x_cm = 0; //correction
            if (isNaN(len_y_cm)) len_y_cm = 0; //correction
            var pointfrom = global2local({ x: points[points.length - 1].x, y: points[points.length - 1].y }),
              pointto = global2local({ x: x, y: y });

            //Check for lineintersection for current position
            var checkpoint = false;
            if (snappoint) {
              checkpoint = snappoint;
            } else {
              checkpoint = local2global(pointto);
            }
            if (!checkForValidPoint(checkpoint)) {
              strokeatts.style = 'Dash';
            }

            //Check if mouse is over area
            if (ev.gfxTarget.getShape().type === 'polyline' && !snappoint && selectedTool !== 'cut-out') {
              strokeatts.style = 'Dash';
            }

            //render the temporary feedback line
            onmoveShapes.push(
              (templine = group
                .createLine({ x1: pointfrom.x, y1: pointfrom.y, x2: pointto.x, y2: pointto.y })
                .setStroke(strokeatts))
            );
            templine['blocksnap'] = true;

            addAngleMeasure(
              { x: x, y: y },
              { x: Math.ceil(ev.pageX - container_position.x), y: Math.ceil(ev.pageY - container_position.y) }
            );

            // After first line has been drawn render the length measurements
            if (!isNaN(vpx2cm)) {
              const lenCmText = numberFormatter.formatOutput(cmToMm(len_cm), formattingPattern);
              onmoveShapes.push(
                group
                  .createText({
                    x: pointto.x + 5,
                    y: pointto.y - 5,
                    text: lenCmText,
                    align: 'start',
                  })
                  .setFill('black')
                  .setFont({ family: 'sans-serif', size: '12.5px' })
              );
              const lenXCmText = numberFormatter.formatOutput(cmToMm(len_x_cm), formattingPattern, false);
              const lenYCmText = numberFormatter.formatOutput(cmToMm(len_y_cm), formattingPattern, false);
              onmoveShapes.push(
                group
                  .createText({
                    x: pointto.x - 5,
                    y: pointto.y + 13,
                    text: '(' + lenXCmText + ' | ' + lenYCmText + ')',
                    align: 'end',
                  })
                  .setFill('black')
                  .setFont({ family: 'sans-serif', size: '12.5px' })
              );
            }
          }
        }

        /*
         * Snapping Checks
         * The first match gets applied and all others ignored.
         */
        if (selectedTool === 'slicer') {
          // get and store the current active area (i.e. last area wehre the mouse hovered on)
          if (ev.gfxTarget.getShape().type === 'polyline' && ev.gfxTarget.areaID != undefined && sliceconfig.length) {
            if (!sliceAreaID) {
              sliceAreaID = ev.gfxTarget.areaID;
              redraw();
            } else if (sliceAreaID != ev.gfxTarget.areaID) {
              sliceAreaID = ev.gfxTarget.areaID;
              redraw();
            }
          }

          //check against the points of completed areas
          if (!snappoint) {
            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                for (var i = data[id].points.length - 1; i >= 0; --i) {
                  if (Math.abs(x - data[id].points[i].x) < mindist && Math.abs(y - data[id].points[i].y) < mindist) {
                    x = data[id].points[i].x;
                    y = data[id].points[i].y;
                    snappoint = data[id].points[i];
                    snappoint['snapx'] = true;
                    snappoint['snapy'] = true;
                    snappoint['areaID'] = id;
                  }
                }
              }
            }
          }

          // check against the lines of completed areas
          if (!snappoint) {
            checkDistancePoint2Lines({ x: mousexpos, y: mouseypos }, sliceAreaID);
            checkCombinedCornerSnappingSlice({ x: mousexpos, y: mouseypos });
          }

          // show the snappoint indicator, if any match was found in the checks above
          if (snappoint) {
            showSnapIndicator(snappoint);
          }

          /*
           * check if the current mouseposition represents a valid slicepoint
           * and draw a temporary feedbackline based on this decision.
           */
          sliceinvalid = false;
          if (sliceconfig.length) {
            var x = Math.abs(mousexpos - sliceconfig[0].point.x) < mindist ? sliceconfig[0].point.x : mousexpos,
              y = Math.abs(mouseypos - sliceconfig[0].point.y) < mindist ? sliceconfig[0].point.y : mouseypos,
              angle =
                sliceconfig.length > 1
                  ? PTU.calcAngle(sliceconfig[0].point, sliceconfig[1].point, { x: mousexpos, y: mouseypos })
                  : PTU.calcAngle(
                      { x: mousexpos, y: mouseypos },
                      { x: sliceconfig[0].point.x, y: sliceconfig[0].point.y },
                      { x: sliceconfig[0].point.x + 0.01, y: sliceconfig[0].point.y }
                    );

            if ((sliceconfig.length <= 1 || Math.abs(angle) > minangle) && selectedTool === 'slicer') {
              // Remove line and labels created by previous move event.
              // Instead of whole redraw for performance reasons.
              clearOnMoveShapes();

              var pointfrom = global2local({ x: sliceconfig[0].point.x, y: sliceconfig[0].point.y }),
                pointto = global2local({ x: x, y: y });

              if (snappoint) {
                checkpoint = snappoint;
              } else {
                checkpoint = local2global(pointto);
              }

              if (!snappoint) {
                strokeatts.style = 'Dash';
                sliceinvalid = true;
              }

              //detect intersection with lines
              if (!sliceinvalid && _.size(data)) {
                if (detectIntersectionWithArea(sliceconfig[0].point, checkpoint)) {
                  strokeatts.style = 'Dash';
                  sliceinvalid = true;
                }
              }

              if (!sliceinvalid) {
                var slice_angle = PTU.calcAngle(checkpoint, sliceconfig[0].point, {
                  x: sliceconfig[0].point.x + 1,
                  y: sliceconfig[0].point.y,
                });
                slice_angle = Math.abs(Math.round(slice_angle * (180 / Math.PI)));

                if (sliceconfig[0].linesegment != undefined && sliceconfig[0].linesegment[sliceAreaID] == undefined) {
                  strokeatts.style = 'Dash';
                  sliceinvalid = true;
                } else if (sliceconfig[0].linesegment != undefined) {
                  var sliceLineSegment = sliceconfig[0].linesegment[sliceAreaID];
                  var sliceLineSegment_angle = PTU.calcAngle(
                    sliceLineSegment.p1,
                    { x: sliceLineSegment.p1.x + 1, y: sliceLineSegment.p1.y },
                    sliceLineSegment.p2
                  );

                  sliceLineSegment_angle = Math.abs(Math.round(sliceLineSegment_angle * (180 / Math.PI)));

                  if (
                    Math.abs(sliceLineSegment_angle - slice_angle) < 2 ||
                    Math.abs(sliceLineSegment_angle - Math.abs(slice_angle - 180)) < 2
                  ) {
                    strokeatts.style = 'Dash';
                    sliceinvalid = true;
                  }
                } else {
                  var apoints = data[sliceAreaID].points;

                  var pointidx = false;
                  for (var i = 0; i < apoints.length; i++) {
                    if (sliceconfig[0].point.x == apoints[i].x && sliceconfig[0].point.y == apoints[i].y) {
                      pointidx = i;
                    }
                  }

                  if (pointidx == false) {
                    // snappoint returns a point of a earlier added separation line so should actually be a line.
                    // Find the linesegment where the point lies and proceed with the segment
                    var areapoints = data[sliceAreaID].points;
                    jQuery.each(areapoints, function (idx, point) {
                      var lineseg = false;
                      if (idx < areapoints.length - 1) {
                        lineseg = new parkside.line_segment(point, areapoints[idx + 1]);
                      } else {
                        lineseg = new parkside.line_segment(point, areapoints[0]);
                      }

                      var intersecPoint = lineseg.pointProjection(sliceconfig[0].point);
                      //

                      if (intersecPoint.x === sliceconfig[0].point.x && intersecPoint.y === sliceconfig[0].point.y) {
                        // inject the found linesegment to sliceconfig
                        sliceconfig[0].linesegment = {};
                        sliceconfig[0].linesegment[sliceAreaID] = lineseg;

                        var sliceLineSegment = sliceconfig[0].linesegment[sliceAreaID];
                        var sliceLineSegment_angle = PTU.calcAngle(
                          sliceLineSegment.p1,
                          { x: sliceLineSegment.p1.x + 1, y: sliceLineSegment.p1.y },
                          sliceLineSegment.p2
                        );

                        sliceLineSegment_angle = Math.abs(Math.round(sliceLineSegment_angle * (180 / Math.PI)));

                        if (
                          Math.abs(sliceLineSegment_angle - slice_angle) < 2 ||
                          Math.abs(sliceLineSegment_angle - Math.abs(slice_angle - 180)) < 2
                        ) {
                          strokeatts.style = 'Dash';
                          sliceinvalid = true;
                        }
                        return false; //stop jQuery.each()
                      }
                    });
                  } else {
                    if (pointidx == 0) {
                      var sliceLineSegment_angle1 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[pointidx + 1]
                      );
                      var sliceLineSegment_angle2 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[apoints.length - 1]
                      );
                    } else if (pointidx == apoints.length - 1) {
                      var sliceLineSegment_angle1 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[0]
                      );
                      var sliceLineSegment_angle2 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[pointidx - 1]
                      );
                    } else {
                      var sliceLineSegment_angle1 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[pointidx + 1]
                      );
                      var sliceLineSegment_angle2 = PTU.calcAngle(
                        apoints[pointidx],
                        { x: apoints[pointidx].x + 1, y: apoints[pointidx].y },
                        apoints[pointidx - 1]
                      );
                    }

                    sliceLineSegment_angle1 = Math.abs(Math.round(sliceLineSegment_angle1 * (180 / Math.PI)));
                    sliceLineSegment_angle2 = Math.abs(Math.round(sliceLineSegment_angle2 * (180 / Math.PI)));

                    if (
                      Math.abs(sliceLineSegment_angle1 - slice_angle) < 2 ||
                      Math.abs(sliceLineSegment_angle1 - Math.abs(slice_angle - 180)) < 2
                    ) {
                      strokeatts.style = 'Dash';
                      sliceinvalid = true;
                    } else if (
                      Math.abs(sliceLineSegment_angle2 - slice_angle) < 2 ||
                      Math.abs(sliceLineSegment_angle2 - Math.abs(slice_angle - 180)) < 2
                    ) {
                      strokeatts.style = 'Dash';
                      sliceinvalid = true;
                    }
                    if (sliceinvalid == true) {
                      if (pointidx == 0) {
                        var lineseg1 = new parkside.line_segment(apoints[pointidx], apoints[pointidx + 1]);
                        var lineseg2 = new parkside.line_segment(apoints[pointidx], apoints[apoints.length - 1]);
                      } else if (pointidx == apoints.length - 1) {
                        var lineseg1 = new parkside.line_segment(apoints[pointidx], apoints[0]);
                        var lineseg2 = new parkside.line_segment(apoints[pointidx], apoints[pointidx - 1]);
                      } else {
                        var lineseg1 = new parkside.line_segment(apoints[pointidx], apoints[pointidx + 1]);
                        var lineseg2 = new parkside.line_segment(apoints[pointidx], apoints[pointidx - 1]);
                      }

                      if (
                        !lineseg1.pointOnSegment({ x: snappoint.x, y: snappoint.y }) &&
                        !lineseg2.pointOnSegment({ x: snappoint.x, y: snappoint.y })
                      ) {
                        strokeatts.style = 'Solid';
                        sliceinvalid = false;
                      }
                    }
                  }
                }
              }

              if (snappoint) {
                pointto = global2local(snappoint);
              }

              onmoveShapes.push(
                (templine = group
                  .createLine({ x1: pointfrom.x, y1: pointfrom.y, x2: pointto.x, y2: pointto.y })
                  .setStroke(strokeatts))
              );
            }
          }
        } else if (selectedTool === 'eraser') {
          // check against the lines of completed areas
          checkDistancePoint2Lines({ x: mousexpos, y: mouseypos }, true);
          if (snappoint) {
            var checkpoint1 = snappoint.linesegment.p1;
            var checkpoint2 = snappoint.linesegment.p2;
            var findCounter = 0;
            var findAreas = [];

            //find the areas in which the line exists
            for (var id in data) {
              if (data.hasOwnProperty(id)) {
                var found_1 = false;
                var found_2 = false;
                for (var i = data[id].points.length - 1; i >= 0; --i) {
                  if (data[id].points[i].x == checkpoint1.x && data[id].points[i].y == checkpoint1.y) {
                    found_1 = true;
                  }
                  if (data[id].points[i].x == checkpoint2.x && data[id].points[i].y == checkpoint2.y) {
                    found_2 = true;
                  }
                }
                if (found_1 && found_2) {
                  findCounter++;
                  findAreas.push(id);
                }
              }
            }

            if (findCounter == 2) {
              //go on if the line exists only in 2 areas and find out if these two have other matching points
              var pointarr1 = data[findAreas[0]].points;
              var pointarr2 = data[findAreas[1]].points;
              var matchcount = 0;

              jQuery.each(pointarr1, function (index, point1) {
                jQuery.each(pointarr2, function (index, point2) {
                  if (point1.x == point2.x && point1.y == point2.y) {
                    matchcount++;
                  }
                });
              });

              if (matchcount < 3) {
                var locp1 = global2local(checkpoint1);
                var locp2 = global2local(checkpoint2);
                onmoveShapes.push(
                  group
                    .createLine({ x1: locp1.x, y1: locp1.y, x2: locp2.x, y2: locp2.y })
                    .setStroke({ width: 3, color: 'red' })
                );
                uniteconfig = { points: [checkpoint1, checkpoint2], areas: findAreas };
              } else {
                uniteconfig = false;
              }
            } else {
              uniteconfig = false;
            }
          }
        } else if (selectedTool === 'mover') {
          //check against the points of completed areas
          movepoint = false;

          for (var id in data) {
            if (data.hasOwnProperty(id)) {
              for (var i = data[id].points.length - 1; i >= 0; --i) {
                if (Math.abs(x - data[id].points[i].x) < mindist && Math.abs(y - data[id].points[i].y) < mindist) {
                  x = data[id].points[i].x;
                  y = data[id].points[i].y;
                  movepoint = data[id].points[i];
                  movepoint['snapx'] = true;
                  movepoint['snapy'] = true;
                  movepoint['areaID'] = id;
                }
              }
            }
          }

          // show the snappoint indicator, if any match was found in the checks above
          if (movepoint) {
            switchCursor('grab');
            showSnapIndicator(movepoint);
          } else {
            switchCursor('move');
          }
        }
      });

      var addAngleMeasure = function (refPoint, mousepoint) {
        let disp_angle = PTU.calcAngle(
          { x: refPoint.x, y: refPoint.y },
          { x: points[points.length - 1].x, y: points[points.length - 1].y },
          { x: points[points.length - 1].x + 0.01, y: points[points.length - 1].y }
        );

        //reference point to check for negative degrees
        var locLastPoint = global2local(points[points.length - 1]);

        //correct NaN when on 0 or 180 degrees
        if (isNaN(disp_angle)) {
          if (mousepoint.x >= locLastPoint.x) {
            disp_angle = 0;
          } else {
            disp_angle = Math.PI;
          }
        }

        disp_angle = Math.floor(disp_angle * (180 / Math.PI));

        // negate angle value if mousepointere is below last point
        if (Math.ceil(locLastPoint.y) < mousepoint.y) {
          disp_angle *= -1;
        }

        onmoveShapes.push(
          group
            .createText({
              x: locLastPoint.x + 10,
              y: locLastPoint.y + 3,
              text: disp_angle + '°',
              align: 'left',
            })
            .setFill('black')
            .setFont({ family: 'sans-serif', size: '12.5px' })
        );
      };

      var switchTool = function (toTool, cursor) {
        selectedTool = toTool;

        if (points.length && ['slicer', 'eraser', 'area-remover', 'cut-out'].includes(toTool)) {
          points.length = 0;
        }

        if (cursor) {
          switchCursor(cursor);
        } else {
          switchCursor('default');
        }

        if (selectedTool != 'slicer' && selectedTool != 'eraser' && selectedTool != 'area-remover') {
          jQuery('#toolbar .tool-info-text').hide();
          jQuery('#tabs').show();
          jQuery('#toolbar').css('background-color', '#f7f7f7');
        }
      };

      /* Definition of the actions of the toolbar buttons
			----------------------------------------------------*/

      jQuery('#draw-tool').bind('click', function () {
        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');
        switchTool('drawer', 'crosshair');
        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        redraw();
      });

      jQuery('#move-tool').bind('click', function () {
        if (selectedTool == 'area-remover') {
          selectedTool = undefined; //to prevent loop in redraw()
          redraw();
        }

        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');

        if (selectedTool !== 'mover') {
          switchTool('mover', 'move');

          // draw the edge points when the move tool is enabled the first time
          for (var id in data) {
            if (data.hasOwnProperty(id)) {
              var a = data[id].points.slice(0);
              jQuery.each(a, function (index, point) {
                a[index] = global2local(point);
              });
              for (i = 0; i < a.length; ++i) {
                group
                  .createCircle({ cx: a[i].x, cy: a[i].y, r: 2.5 })
                  .moveToFront()
                  .setStroke({ color: '#be0000', width: 2 })
                  .setFill('#be0000');
              }
            }
          }
        }

        moveableObj = new dojox.gfx.Moveable(group);
        dojo.connect(moveableObj, 'onMoved', onMoved);
        dojo.connect(moveableObj, 'onMoveStart', onMoveStart);
        dojo.connect(moveableObj, 'onMoveStop', onMoveStop);

        clearOnMoveShapes();
      });

      var onMoved = function (mover, shift) {
        if (movepoint) {
          let newPoint = _.clone(movepoint, false);
          newPoint.x += shift.dx * Math.pow(zoomMultiplier, -viewData.zoomlevel);
          newPoint.y += shift.dy * Math.pow(zoomMultiplier, -viewData.zoomlevel);
          // replace the existing point with the shifted one
          for (let i = 0; i < data[movepoint.areaID].points.length; i++) {
            if (
              movepoint.x === data[movepoint.areaID].points[i].x &&
              movepoint.y === data[movepoint.areaID].points[i].y
            ) {
              data[movepoint.areaID].points[i].x = newPoint.x;
              data[movepoint.areaID].points[i].y = newPoint.y;
              movepoint.index = i;
            }
          }

          redraw();

          snappoint = false;

          for (let i = 0; i < data[movepoint.areaID].points.length; i++) {
            if (
              Math.abs(data[movepoint.areaID].points[i].x - newPoint.x) > 0.001 ||
              Math.abs(data[movepoint.areaID].points[i].y - newPoint.y > 0.001)
            ) {
              checkCornerSnapping(data[movepoint.areaID].points[i], newPoint);
              if (snappoint) {
                showSnapIndicator(snappoint);
              }
            }
          }
        } else {
          viewData.pan.x += shift.dx;
          viewData.pan.y += shift.dy;
          redraw();
        }
      };
      var onMoveStart = function () {
        addStatusToHistory();
        switchCursor('grabbing');
      };
      var onMoveStop = function () {
        switchCursor('grab');

        if (!movepoint) return;

        let moveValid = true;
        let checkPoint = snappoint || data[movepoint.areaID].points[movepoint.index];

        // detect 3 points in a row for triangles
        if (data[movepoint.areaID].points.length === 3) {
          moveValid = isValidTriangle(
            checkPoint,
            movepoint.index,
            history[history.length - 1].data[movepoint.areaID].points,
            movepoint.areaID
          );
        } else {
          moveValid = isValidMove(
            checkPoint,
            movepoint.index,
            history[history.length - 1].data[movepoint.areaID].points,
            movepoint.areaID
          );
        }

        //detect intersections of moved points with drawn areas and cutouts
        switch (movepoint.index) {
          case 0:
            if (
              detectIntersectionWithArea(
                data[movepoint.areaID].points[1],
                data[movepoint.areaID].points[movepoint.index]
              ) ||
              detectIntersectionWithArea(
                data[movepoint.areaID].points[data[movepoint.areaID].points.length - 1],
                data[movepoint.areaID].points[movepoint.index]
              )
            ) {
              moveValid = false;
            }
            break;
          case data[movepoint.areaID].points.length - 1:
            if (
              detectIntersectionWithArea(
                data[movepoint.areaID].points[0],
                data[movepoint.areaID].points[movepoint.index]
              ) ||
              detectIntersectionWithArea(
                data[movepoint.areaID].points[data[movepoint.areaID].points.length - 2],
                data[movepoint.areaID].points[movepoint.index]
              )
            ) {
              moveValid = false;
            }
            break;
          default:
            if (
              detectIntersectionWithArea(
                data[movepoint.areaID].points[movepoint.index - 1],
                data[movepoint.areaID].points[movepoint.index]
              ) ||
              detectIntersectionWithArea(
                data[movepoint.areaID].points[movepoint.index + 1],
                data[movepoint.areaID].points[movepoint.index]
              )
            ) {
              moveValid = false;
            }
            break;
        }

        if (!moveValid) {
          // undo point move
          if (history.length > 1) {
            data = dojo.clone(history[history.length - 1].data);
            points = dojo.clone(history[history.length - 1].points);
          }
          snappoint = false;
          redraw();
          return;
        }

        if (snappoint) {
          data[movepoint.areaID].points[movepoint.index].x = snappoint.x;
          data[movepoint.areaID].points[movepoint.index].y = snappoint.y;
          snappoint = false;
        }

        mergeOverlappingCutouts(data);
        removeOrphanedCutouts(data);
        redraw();
      };

      //bottom bar at fullscreen view
      var $bottomBar = jQuery('#bottom-bar, .fixed-bottom-bar-background').clone();
      $bottomBar.find('.btn-next').bind('click', function (e) {
        viewData.pan.x -= container_position_embedded.x;
        viewData.pan.y -= container_position_embedded.y;
        jQuery('.tp_grundriss .btn-next').click();
      });

      jQuery('#fullscreen').bind('click', function () {
        viewData.pan.x += container_position.x;
        viewData.pan.y += container_position.y;

        jQuery('#draw-section').prependTo('body');
        jQuery('#draw-section').addClass('fullscreen');
        jQuery('#mainwrapper').hide();
        jQuery('body').css('margin-bottom', 0);

        jQuery('body').addClass('terrassenplaner');

        $bottomBar.addClass('fixed-bottom-bar');
        $bottomBar.css({ width: '100%', 'border-top': '1px solid #ccc', 'max-width': 'initial', height: '60px' });
        $bottomBar.children('fieldset').css('padding-right', 10);
        jQuery('body').append($bottomBar);

        jQuery('#close-fullscreen').show();
        jQuery(this).hide();
        jQuery(window).trigger('resize');
      });

      jQuery(window).bind('resize', function () {
        jQuery('#draw-section.fullscreen').css('height', jQuery(window).height() - 60 + 'px');
        jQuery('#draw-sections.fullscreen').css('width', jQuery(window).width() - toolbarPadding + 'px');

        jQuery('.fullscreen #canvas').css('height', jQuery(window).height() - 60 + 'px');
        jQuery('.fullscreen #canvas').css('width', jQuery(window).width() - toolbarPadding + 'px');

        jQuery('.fullscreen #toolbar').css('height', jQuery('#canvas').height() + 'px');
        container_position = dojo.position(container, true);
        s.setDimensions(jQuery('#canvas').width() - 1, jQuery('#canvas').height()); //width()-1 to be combatible with IE9+
        redraw();
      });

      jQuery('#close-fullscreen').bind('click', function () {
        jQuery('#draw-section').prependTo('#draw-container');
        jQuery('#draw-section').removeClass('fullscreen');

        jQuery('body').removeClass('terrassenplaner');

        $bottomBar.detach();

        jQuery('#mainwrapper').show();
        jQuery('body').css('margin-bottom', 20);
        jQuery('#fullscreen').show();

        jQuery('#draw-section').css('height', '');
        jQuery('#draw-section').css('width', '');

        jQuery('#canvas').css('height', '');
        jQuery('#canvas').css('width', '');

        jQuery('#toolbar').css('height', jQuery('#canvas').height() + 'px');

        jQuery(this).hide();
        container_position = dojo.position(container, true);
        viewData.pan.x -= container_position.x;
        viewData.pan.y -= container_position.y;
        s.setDimensions(container_visible_dimension.w, container_visible_dimension.h);

        redraw();
        jQuery(window).trigger('scroll');
      });

      jQuery('#toggle-measurements').bind('click', function () {
        measurementToggle = !measurementToggle;
        if (measurementToggle) {
          jQuery('#toggle-measurements').addClass('active');
          redraw();
        } else {
          jQuery('#toggle-measurements').removeClass('active');
          redraw();
        }
      });

      jQuery('#zoom-in').bind('click', function () {
        applyZoom('in');
      });

      jQuery('#zoom-out').bind('click', function () {
        applyZoom('out');
      });

      jQuery('#cut-out').bind('click', function () {
        if (!isToolEnabled('cut-out')) {
          alert(
            tp_trans.trans(
              'no_cutouts_multiple_areas_alert',
              'Bei mehreren Flächen können keine Aussparungen gezeichnet werden!'
            )
          );
          return;
        }
        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');
        switchTool('cut-out', 'crosshair');
        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        redraw();
      });

      var spaceKeyDown = false;
      jQuery('#canvas').bind('mousewheel DOMMouseScroll', function (ev) {
        if (spaceKeyDown) {
          ev.stopPropagation();
          ev.preventDefault();
          var scrollDelta = ev.originalEvent.wheelDelta || -ev.originalEvent.detail; // for FF compability
          if (scrollDelta > 0) {
            var mousepos = {
              x: ev.pageX || ev.originalEvent.pageX - container_position.x,
              y: ev.pageY || ev.originalEvent.pageY - container_position.y,
            };
            applyZoom('in', mousepos);
          } else if (scrollDelta < 0) {
            var mousepos = {
              x: ev.pageX || ev.originalEvent.pageX - container_position.x,
              y: ev.pageY || ev.originalEvent.pageY - container_position.y,
            };
            applyZoom('out', mousepos);
          }
        }
      });

      jQuery('#undo').bind('click', function () {
        if (history.length > 1) {
          redos.push(history.pop());
          data = dojo.clone(history[history.length - 1].data);
          points = dojo.clone(history[history.length - 1].points);
        } else if (history.length) {
          redos.push(history.pop());
          points = [];
        }

        if (points.length === 1 && !_.size(data) && jQuery('#canvas').attr('data-image').length) {
          historyVpx2cm = vpx2cm;
          vpx2cm = NaN;
        }

        if (!history.length) {
          jQuery('#undo').addClass('disabled');
        }
        jQuery('#redo').removeClass('disabled');

        sliceAreaID = false;
        sliceconfig.length = 0;

        redraw();
      });

      jQuery('#redo').bind('click', function () {
        if (redos.length) {
          history.push(redos.pop());
          data = dojo.clone(history[history.length - 1].data);
          points = dojo.clone(history[history.length - 1].points);
        }

        if (points.length === 2 && !_.size(data) && jQuery('#canvas').attr('data-image').length) {
          vpx2cm = historyVpx2cm;
          historyVpx2cm = NaN;
        }

        if (!redos.length) {
          jQuery('#redo').addClass('disabled');
        }
        jQuery('#undo').removeClass('disabled');

        sliceAreaID = false;
        sliceconfig.length = 0;

        redraw();
      });

      jQuery('#area-remove').bind('click', function () {
        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');
        switchTool('area-remover');

        //Tool Info Text
        jQuery('#toolbar .tool-info-text').hide();
        jQuery('#toolbar .tool-info-text.area-remover').show();
        jQuery('#tabs').hide();
        jQuery('#toolbar').css('background-color', '#f0f0f0');

        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        redraw();
      });

      jQuery('#slice').bind('click', function () {
        if (!isToolEnabled('slice')) {
          alert(
            tp_trans.trans(
              'multiple_areas_no_slicing_alert',
              'Bei Verwendung von Aussparungen können keine Flächen geteilt werden!'
            )
          );
          return;
        }

        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');
        switchTool('slicer', 'crosshair');

        //Tool Info Text
        jQuery('#toolbar .tool-info-text').hide();
        jQuery('#toolbar .tool-info-text.slicer').show();
        jQuery('#tabs').hide();
        jQuery('#toolbar').css('background-color', '#f0f0f0');

        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        redraw();
      });

      jQuery('#erase').bind('click', function () {
        if (!isToolEnabled('erase')) {
          alert(
            tp_trans.trans(
              'multiple_areas_no_slicing_alert',
              'Bei Verwendung von Aussparungen können keine Flächen geteilt werden!'
            )
          );
          return;
        }
        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        jQuery('.toolbar-button.active').removeClass('active');
        jQuery(this).addClass('active');
        switchTool('eraser', 'pointer');

        //Tool Info Text
        jQuery('#toolbar .tool-info-text').hide();
        jQuery('#toolbar .tool-info-text.eraser').show();
        jQuery('#tabs').hide();
        jQuery('#toolbar').css('background-color', '#f0f0f0');

        if (moveableObj != 'undefined') {
          moveableObj.destroy();
        }
        redraw();
      });

      jQuery('input[name=direct-input-rotation]').keyup(function (e) {
        var input = jQuery(this).val().replace(/,/g, '.');
        if (!isNaN(parseFloat(input))) {
          viewData.rotation.deg = parseFloat(input);
        } else {
          viewData.rotation.deg = 0.0;
        }
        redraw();
      });

      var timeoutId = 0;
      var intervalId = 0;

      jQuery('#rotate-right')
        .bind('mousedown', function () {
          viewData.rotation.deg += 0.5;
          jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
          redraw();
          timeoutId = setTimeout(function () {
            intervalId = setInterval(function () {
              viewData.rotation.deg += 0.5;
              jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
              redraw();
            }, 100);
          }, 400);
        })
        .bind('mouseup mouseleave', function () {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        });

      jQuery('#rotate-left')
        .bind('mousedown', function () {
          viewData.rotation.deg -= 0.5;
          jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
          redraw();
          timeoutId = setTimeout(function () {
            intervalId = setInterval(function () {
              viewData.rotation.deg -= 0.5;
              jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
              redraw();
            }, 100);
          }, 400);
        })
        .bind('mouseup mouseleave', function () {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        });

      jQuery('#grid-toggle').bind('click', function () {
        gridToggle = !gridToggle;
        redraw();
      });

      // Direct coordinates tab
      jQuery('#direct-point').bind('click', function () {
        if (isImperial) {
          var imperialHandlerX = new ImperialInputHandler(document.getElementById('drawing_tool_manual_point_x'));
          var imperialHandlerY = new ImperialInputHandler(document.getElementById('drawing_tool_manual_point_y'));
          var coordX = mmToCm(imperialHandlerX.value) * vpx2cm;
          var coordY = mmToCm(imperialHandlerY.value) * vpx2cm * -1;
          if (!isNaN(coordX) && !isNaN(coordY) && !isNaN(vpx2cm)) {
            addPoint({
              x: points[points.length - 1].x + parseFloat(coordX),
              y: points[points.length - 1].y + parseFloat(coordY),
            });
          }
          imperialHandlerX.reset();
          imperialHandlerY.reset();
        } else {
          // Get value for coordinates from input fields.
          // Add the new point to the points array.
          var xstring = jQuery('input[name=direct-input-x]')
            .val()
            .replace(/,/g, '.')
            .replace(/[^0-9\+\-\.]/g, '');
          var ystring = jQuery('input[name=direct-input-y]')
            .val()
            .replace(/,/g, '.')
            .replace(/[^0-9\+\-\.]/g, '');
          var xVal = parseFloat(eval(xstring)) * vpx2cm;
          var yVal = parseFloat(eval(ystring)) * vpx2cm * -1;

          if (!isNaN(xVal) && !isNaN(yVal) && !isNaN(vpx2cm)) {
            addPoint({
              x: points[points.length - 1].x + parseFloat(xVal),
              y: points[points.length - 1].y + parseFloat(yVal),
            });
          }
          //return focus to first input field of the tab
          jQuery('input[name=direct-input-x]').focus();
          //clear the input fields
          jQuery('#tabs input[type=text]').val('');
        }
      });

      jQuery('input[name=direct-input-x], input[name=direct-input-y]').keyup(function (event) {
        if (
          event.which === 13 &&
          jQuery('input[name=direct-input-x]').val().length &&
          jQuery('input[name=direct-input-y]').val().length
        ) {
          jQuery('#direct-point').click();
        }
      });

      // Direct line & angle tab
      jQuery('#direct-line').bind('click', function () {
        /*
         * Get legth (cm) and angle (degree) from input fields.
         * Convert angle to radian value, calculate coordinates of
         * endpoint of the line to be added and it to the points array.
         */
        if (points.length) {
          var length = 0;
          if (isImperial) {
            var imperialHandlerLength = new ImperialInputHandler(
              document.getElementById('drawing_tool_manual_point_length')
            );
            length = mmToCm(imperialHandlerLength.value) * vpx2cm;
          } else {
            length = parseFloat(jQuery('input[name=direct-input-length]').val().replace(/,/g, '.')) * vpx2cm;
          }
          var angle = parseFloat(jQuery('input[name=direct-input-angle]').val().replace(/,/g, '.'));
          if (!isNaN(length) && !isNaN(angle) && !isNaN(vpx2cm)) {
            angle = -((angle * Math.PI) / 180); //convertion to radian
            var lpoint = points[points.length - 1];
            addPoint({ x: length * Math.cos(angle) + lpoint.x, y: length * Math.sin(angle) + lpoint.y });
          }
        }
        if (isImperial) {
          imperialHandlerLength.reset();
        } else {
          //return focus to first input field of the tab
          jQuery('input[name=direct-input-length]').focus();
          //clear the input fields
          jQuery('#tabs input[type=text]').val('');
        }
      });

      jQuery('input[name=direct-input-length], input[name=direct-input-angle]').keyup(function (event) {
        if (
          event.which === 13 &&
          jQuery('input[name=direct-input-length]').val().length &&
          jQuery('input[name=direct-input-angle]').val().length
        ) {
          jQuery('#direct-line').click();
        }
      });

      jQuery('input[name=natural_length_input]').keyup(function (event) {
        if (event.which === 13) {
          jQuery('#natural-length .apply-link').click();
        }
      });

      !(function () {
        //notification when direct input is not available
        var error_msg_str =
          '<div id="input-error-msg" class="grundriss-tooltip">' +
          '<div class="msg-text"></div>' +
          '<div class="msg-arrow"><img src="images/error-msg-arrow.png"></img></div>' +
          '</div>';

        var errorTimeoutID = false;

        jQuery('#tabs .disabled input, #tabs .disabled .imperial-input-group').live('click', function (e) {
          clearTimeout(errorTimeoutID);
          jQuery('#input-error-msg').remove();
          jQuery('#tabs .disabled input').removeAttr('style');

          var $error_msg = jQuery(error_msg_str);
          var $this = jQuery(this);

          $this.blur();

          $this.css({
            border: '1px solid #be0000',
            '-moz-border-radius': '3px',
            '-webkit-border-radius': '3px',
            '-khtml-border-radius': '3px',
            'border-radius': '3px',
          });
          jQuery('body').prepend($error_msg);
          if (isNaN(vpx2cm)) {
            jQuery('#input-error-msg .msg-text').html($this.attr('data-error-novpx'));
          } else {
            jQuery('#input-error-msg .msg-text').html($this.attr('data-error-vpx'));
          }

          jQuery('#input-error-msg').click(function (e) {
            jQuery(this).remove();
            $this.removeAttr('style');
            clearTimeout(errorTimeoutID);
          });

          $error_msg.css(
            'top',
            $this.offset().top -
              jQuery('#input-error-msg .msg-text').outerHeight() -
              jQuery('#input-error-msg .msg-arrow').height()
          );
          $error_msg.css('left', $this.offset().left + $this.outerWidth() / 2 - $error_msg.width() / 2);

          errorTimeoutID = setTimeout(function () {
            $error_msg.remove();
            $this.removeAttr('style');
          }, 4000);
        });
      })();

      !(function () {
        //tooltip in direct coordinates tab
        var coord_tooltip_msg_str =
          '<div id="input-info" class="grundriss-tooltip">' +
          '<div class="msg-text">' +
          '<div class="coord-icon"><span class="mptp-icon icon-export_coordinates-tooltip"></span></div>' +
          '</div>' +
          '<div class="msg-arrow"><img src="images/error-msg-arrow.png" /></div>' +
          '</div>';
        var tooltipTimeoutID = false;
        jQuery('#coordinates-tab .tooltip-caller').hover(
          function (e) {
            var $tooltip = jQuery(coord_tooltip_msg_str),
              $this = jQuery(this);
            tooltipTimeoutID = window.setTimeout(function () {
              jQuery('body').prepend($tooltip);
              jQuery('#input-info .msg-text').html($this.attr('data-tooltip') + jQuery('#input-info .msg-text').html());
              $tooltip.css(
                'top',
                $this.offset().top -
                  jQuery('#input-info .msg-text').outerHeight() -
                  jQuery('#input-info .msg-arrow').height()
              );
              $tooltip.css('left', $this.offset().left - $this.outerWidth() / 2 - 5 - $tooltip.width() / 2);
            }, 300);
          },
          function (e) {
            clearTimeout(tooltipTimeoutID);
            jQuery('#input-info').remove();
          }
        );
      })();

      jQuery(document).keydown(function (e) {
        if (jQuery('#draw-section:hover').length) {
          switch (e.which) {
            case 32: // SPACE
              e.stopPropagation();
              e.preventDefault();
              if (selectedTool != 'mover') {
                jQuery('#move-tool').click();
              }
              spaceKeyDown = true;
              break;
            case 27: //ESC
              if (selectedTool == 'slicer') {
                sliceAreaID = false;
                sliceconfig.length = 0;
                redraw();
              } else if (selectedTool == 'drawer' && points.length === 1) {
                points.length = 0;
                history.pop();
                redraw();
              }
              break;
            case 38: //UP
              e.preventDefault();
              viewData.pan.y += -4;
              redraw();
              break;
            case 40: //DOWN
              e.preventDefault();
              viewData.pan.y += 4;
              redraw();
              break;
            case 37: //LEFT
              e.preventDefault();
              viewData.pan.x += -4;
              redraw();
              break;
            case 39: //RIGHT
              e.preventDefault();
              viewData.pan.x += 4;
              redraw();
              break;
            case 89: // Y
              if (e.ctrlKey) {
                e.stopPropagation();
                e.preventDefault();
                jQuery('#redo').click();
              }
              break;
            case 90: // Z
              if (e.ctrlKey) {
                e.stopPropagation();
                e.preventDefault();
                jQuery('#undo').click();
              }
              break;
            case 187: // + (also allow =)
              if (isDirectInputActive()) break;
              e.stopPropagation();
              e.preventDefault();
              jQuery('#zoom-in').click();
              break;
            case 107: // + on NumPad
              if (isDirectInputActive()) break;
              e.stopPropagation();
              e.preventDefault();
              jQuery('#zoom-in').click();
              break;
            case 189: // - (also allow _)
              if (isDirectInputActive()) break;
              e.stopPropagation();
              e.preventDefault();
              jQuery('#zoom-out').click();
              break;
            case 109: // - on NumPad
              if (isDirectInputActive()) break;
              e.stopPropagation();
              e.preventDefault();
              jQuery('#zoom-out').click();
              break;
          }
        }
      });

      jQuery(document).keyup(function (e) {
        if (e.which === 32) {
          if (selectedTool === 'mover') {
            jQuery('#draw-tool').click();
          }
          spaceKeyDown = false;
        }
      });

      jQuery('.tp_grundriss .btn-next').bind('click', function (e) {
        /*
         * On click on "Weiter" check if there are complete areas drawn, convert them to JSON,
         * set it as input value and submit the form.
         */
        if (jQuery('.btn-next').hasClass('btn-disabled')) return;

        // unite points which are collinear
        for (var id in data) {
          if (data.hasOwnProperty(id)) {
            uniteCollinearPoints(data[id].points);
          }
        }
        addStatusToHistory();
        redraw();

        jQuery('#close-fullscreen').click();
        jQuery('input[name=drawdata]').val(JSON.stringify(data));
        jQuery('input[name=viewData]').val(JSON.stringify(viewData));
        jQuery('input[name=natural_length_input]').val(vpx2cm);
        jQuery('input[name=history_and_redos]').val(JSON.stringify([history, redos]));
        jQuery('form[name=form_form_grundriss]').submit();
      });

      if (!_.size(data)) {
        //if no areas available init draw tool, else no tool gets selected on load
        jQuery('#draw-tool').click();
      }

      var isDirectInputActive = function () {
        return document.activeElement.name && document.activeElement.name.startsWith('direct-input');
      };

      var renderHelperMeasurements = function (areaID, mousepoint) {
        helperMeasurementsGroup.clear();
        renderVerticalHelperMeasurements(areaID, mousepoint);
        renderHorizontalHelperMeasurements(areaID, mousepoint);
        helperMeasurementsGroup.moveToFront();
      };

      var renderVerticalHelperMeasurements = function (areaID, mousepoint) {
        var g = com.parkside.measure_geometry;
        var poly = _.clone(data[areaID].points);
        var bbox = getBoundingBox(data[areaID].points);
        var xMiddle = bbox.x2 - bbox.x1;

        poly = g.arrayOfPointsSort(poly, 'y');

        var profiles = [];

        // add area borders also to profile array for simpler distance calculation
        profiles.splice(0, 0, {
          start: {
            x: 0,
            y: poly[0].y,
          },
          end: {
            x: 0,
            y: poly[0].y,
          },
        });

        profiles.push({
          start: {
            x: 0,
            y: mousepoint.y,
          },
          end: {
            x: 0,
            y: mousepoint.y,
          },
        });

        profiles.push({
          start: {
            x: 0,
            y: poly[poly.length - 1].y,
          },
          end: {
            x: 0,
            y: poly[poly.length - 1].y,
          },
        });

        // dotted line and background
        helperMeasurementsGroup
          .createRect({
            x: 40,
            y: 0,
            width: 30,
            height: container_position.h,
          })
          .setFill([255, 255, 255, 0.8]);
        helperMeasurementsGroup
          .createLine({
            x1: 60,
            y1: global2local(poly[0]).y,
            x2: 60,
            y2: global2local(poly[poly.length - 1]).y,
          })
          .setStroke({ color: '#979797', style: 'Dash' });
        helperMeasurementsGroup
          .createLine({
            x1: 55,
            y1: global2local(poly[0]).y,
            x2: 65,
            y2: global2local(poly[0]).y,
          })
          .setStroke({ color: '#979797' });
        helperMeasurementsGroup
          .createLine({
            x1: 55,
            y1: global2local(poly[poly.length - 1]).y,
            x2: 65,
            y2: global2local(poly[poly.length - 1]).y,
          })
          .setStroke({ color: '#979797' });

        for (var i = 0; i < profiles.length - 1; i++) {
          if (i > 0) {
            var y = global2local(profiles[i].start).y;
            helperMeasurementsGroup
              .createLine({
                x1: 55,
                y1: y,
                x2: 65,
                y2: y,
              })
              .setStroke({ color: '#979797' });
          }

          var length = Math.abs(Math.round((profiles[i].start.y - profiles[i + 1].start.y) / vpx2cm));
          const textLabel = numberFormatter.formatOutput(cmToMm(length), formattingPattern);

          var text = helperMeasurementsGroup
            .createText({
              x: 45,
              y: (global2local(profiles[i].start).y + global2local(profiles[i + 1].start).y) / 2,
              text: textLabel,
              align: 'middle',
            })
            .setFill('#000')
            .setFont({
              family: 'sans-serif',
              size: '12px',
            });

          rotateText(text, -90);
        }
      };
      var renderHorizontalHelperMeasurements = function (areaID, mousepoint) {
        var g = com.parkside.measure_geometry;
        var poly = _.clone(data[areaID].points);
        var bbox = getBoundingBox(data[areaID].points);
        var xMiddle = bbox.x2 - bbox.x1;

        poly = g.arrayOfPointsSort(poly, 'x');

        var profiles = [];

        // add area borders also to profile array for simpler distance calculation
        profiles.splice(0, 0, {
          start: {
            x: poly[0].x,
            y: x,
          },
          end: {
            x: poly[0].x,
            y: x,
          },
        });

        profiles.push({
          start: {
            x: mousepoint.x,
            y: mousepoint.y,
          },
          end: {
            x: mousepoint.x,
            y: mousepoint.y,
          },
        });

        profiles.push({
          start: {
            x: poly[poly.length - 1].x,
            y: 0,
          },
          end: {
            x: poly[poly.length - 1].x,
            y: 0,
          },
        });

        // dotted line and background

        helperMeasurementsGroup
          .createRect({
            x: 65,
            y: 0,
            width: container_position.w - 110,
            height: 30,
          })
          .setFill([255, 255, 255, 0.8]);
        helperMeasurementsGroup
          .createLine({
            x1: global2local(poly[0]).x,
            y1: 25,
            x2: global2local(poly[poly.length - 1]).x,
            y2: 25,
          })
          .setStroke({ color: '#979797', style: 'Dash' });
        helperMeasurementsGroup
          .createLine({
            x1: global2local(poly[0]).x,
            y1: 20,
            x2: global2local(poly[0]).x,
            y2: 30,
          })
          .setStroke({ color: '#979797' });
        helperMeasurementsGroup
          .createLine({
            x1: global2local(poly[poly.length - 1]).x,
            y1: 20,
            x2: global2local(poly[poly.length - 1]).x,
            y2: 30,
          })
          .setStroke({ color: '#979797' });

        for (var i = 0; i < profiles.length - 1; i++) {
          if (i > 0) {
            var x = global2local(profiles[i].start).x;
            helperMeasurementsGroup
              .createLine({
                x1: x,
                y1: 20,
                x2: x,
                y2: 30,
              })
              .setStroke({ color: '#979797' });
          }

          var length = Math.abs(Math.round((profiles[i].start.x - profiles[i + 1].start.x) / vpx2cm));
          const textLabel = numberFormatter.formatOutput(cmToMm(length), formattingPattern);

          var text = helperMeasurementsGroup
            .createText({
              x: (global2local(profiles[i].start).x + global2local(profiles[i + 1].start).x) / 2,
              y: 15,
              text: textLabel,
              align: 'middle',
            })
            .setFill('#000')
            .setFont({
              family: 'sans-serif',
              size: '12px',
            });
        }
      };

      var getDistancePointToArea = function (mousepoint) {
        /*
         * Checks if the current mouseposition is near an existing arealine. (< min_dist).
         * In that case the snappoint is set to the intersection with the line based on
         * a 90 degeree projection from the current position.
         */

        var min_dist = 10;
        var lineseg = {};

        if (_.size(data)) {
          for (var id in data) {
            if (data.hasOwnProperty(id)) {
              var areapoints = data[id].points;

              jQuery.each(areapoints, function (idx, point) {
                if (idx < areapoints.length - 1) {
                  lineseg = new parkside.line_segment(point, areapoints[idx + 1]);
                } else {
                  lineseg = new parkside.line_segment(point, areapoints[0]);
                }

                var intersecPoint = lineseg.pointProjection(mousepoint);
                var a = intersecPoint.x - mousepoint.x;
                var b = intersecPoint.y - mousepoint.y;
                var distance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

                if (distance >= 0 && lineseg.pointOnSegment(intersecPoint)) {
                  return distance;
                } else {
                  return 0;
                }
              });
            }
          }
        }
      };

      var getBoundingBox = function (points) {
        var box = {};

        box.x1 = Infinity;
        box.y1 = Infinity;
        box.x2 = -Infinity;
        box.y2 = -Infinity;

        for (var i = 0; i < points.length; i++) {
          var x = points[i].x,
            y = points[i].y;
          box.x1 = Math.min(box.x1, x);
          box.y1 = Math.min(box.y1, y);
          box.x2 = Math.max(box.x2, x);
          box.y2 = Math.max(box.y2, y);
        }

        if (points.length === 0) box.minX = box.maxX = box.minY = box.maxY = 0;
        return box;
      };
    });
  });
};
